<template>
  <div class="hello">
    <h1>Gestion électronique des documents</h1>

    <!-- Formulaire d'upload -->
    <div v-if="canUpload" class="upload-section container-fluid">
      <div class="row" style="align-items: stretch;">
        <div class="col-lg-6" style="display: flex; flex-direction: column;">
          <div class="upload-card" style="flex: 1;">
            <div class="upload-card-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
              </svg>
              Nouveau Document
            </div>
            <div class="upload-card-body">
              <form @submit.prevent="uploadDocuments">

                <!-- Zone de drop multi-fichiers -->
                <div class="form-group">
                  <label>Fichiers *</label>
                  <div 
                    class="dropzone"
                    :class="{ 'dropzone-active': isDragging }"
                    @dragover.prevent="isDragging = true"
                    @dragleave.prevent="isDragging = false"
                    @drop.prevent="handleDrop"
                    @click="$refs.fileInput.click()"
                  >
                    <input 
                      ref="fileInput" 
                      type="file" 
                      style="display: none;" 
                      accept=".pdf,.jpg,.jpeg,.png,.heic"
                      multiple
                      @change="handleFileSelect"
                    >
                    <input 
                      ref="cameraInput" 
                      type="file" 
                      style="display: none;" 
                      accept="image/*"
                      capture="environment"
                      @change="handleCameraCapture"
                    >
                    <div v-if="selectedFiles.length === 0" class="dropzone-placeholder">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                        <path d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                      </svg>
                      <p>Glissez vos fichiers ici ou cliquez pour sélectionner</p>
                      <small>PDF, JPG, PNG, HEIC — Plusieurs fichiers possibles</small>
                      <button type="button" class="btn-camera" @click.stop="$refs.cameraInput.click()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
                          <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                        </svg>
                        Prendre une photo
                      </button>
                    </div>
                    <div v-else class="dropzone-files-list">
                      <div class="dropzone-files-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1z"/>
                        </svg>
                        <span>{{ selectedFiles.length }} fichier{{ selectedFiles.length > 1 ? 's' : '' }} sélectionné{{ selectedFiles.length > 1 ? 's' : '' }}</span>
                      </div>
                      <ul class="dropzone-files-items">
                        <li v-for="(entry, index) in selectedFiles" :key="index" class="dropzone-file-item">
                          <div class="file-item-row">
                            <span class="file-name">{{ entry.file.name }}</span>
                            <span class="file-size">{{ formatFileSize(entry.file.size) }}</span>
                            <button type="button" class="btn-remove-file" @click.stop="removeFile(index)" title="Retirer">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                            </button>
                          </div>
                          <div class="file-item-type">
                            <select v-model="entry.forcedTypeId" @click.stop class="file-type-select">
                              <option value="">Détection automatique</option>
                              <option v-for="dtype in documentTypes" :key="dtype.id" :value="dtype.id">{{ dtype.name }}</option>
                            </select>
                          </div>
                        </li>
                      </ul>
                      <div class="dropzone-add-actions">
                        <small class="dropzone-add-more" @click.stop="$refs.fileInput.click()">+ Ajouter d'autres fichiers</small>
                        <small class="dropzone-add-more dropzone-add-camera" @click.stop="$refs.cameraInput.click()">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
                            <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg>
                          Prendre une photo
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Barre de progression multi-fichiers -->
                <div v-if="isUploading" class="upload-progress-section">
                  <div class="upload-progress-header">
                    <span>Traitement en cours : {{ uploadProgress.current }} / {{ uploadProgress.total }}</span>
                    <span class="upload-progress-percent">{{ Math.round((uploadProgress.current / uploadProgress.total) * 100) }}%</span>
                  </div>
                  <div class="upload-progress-bar">
                    <div class="upload-progress-fill" :style="{ width: (uploadProgress.current / uploadProgress.total * 100) + '%' }"></div>
                  </div>
                  <div class="upload-progress-current" v-if="uploadProgress.currentFile">
                    <div class="loader-animation">
                      <div class="loader-box">
                        <div class="loader-circle"></div>
                        <div class="loader-circle"></div>
                        <div class="loader-circle"></div>
                      </div>
                    </div>
                    <div class="analyzing-text">
                      <span class="analyzing-label">Analyse en cours</span>
                      <span class="analyzing-filename">{{ uploadProgress.currentFile }}</span>
                    </div>
                  </div>
                  <ul class="upload-progress-results" v-if="uploadProgress.results.length > 0">
                    <li v-for="(result, i) in uploadProgress.results" :key="i" :class="result.success ? (result.warn ? 'result-warn' : 'result-success') : 'result-error'">
                      <!-- succès normal -->
                      <svg v-if="result.success && !result.warn" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                      <!-- succès avec type non reconnu -->
                      <svg v-else-if="result.success && result.warn" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                      <!-- erreur -->
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                      </svg>
                      <span>{{ result.filename }} — {{ result.message }}</span>
                    </li>
                  </ul>
                </div>

                <button 
                  type="submit" 
                  class="btn-submit"
                  :disabled="selectedFiles.length === 0 || isUploading"
                >
                  <span v-if="isUploading">
                    <div class="spinner-inline"></div>
                    Traitement en cours...
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7z"/>
                    </svg>
                    Analyser {{ selectedFiles.length > 1 ? 'les ' + selectedFiles.length + ' documents' : 'le document' }}
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>

        <!-- Opérations panel -->
        <div class="col-lg-6" style="display: flex; flex-direction: column;">
          <div class="info-card" style="flex: 1; display: flex; flex-direction: column;">
            <div class="info-card-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
              </svg>
              Opérations
            </div>
            <div class="info-card-body">
              <!-- Compteurs cliquables -->
              <div class="stats-section">
                <div class="stat-item stat-pending" :class="{ active: filters.workflow_status === 'en_attente' }" @click="filterByWorkflow('en_attente')">
                  <span class="stat-number">{{ pendingCount }}</span>
                  <span class="stat-label">En attente</span>
                </div>
                <div class="stat-item stat-completed" :class="{ active: filters.workflow_status === 'in_progress' }" @click="filterByWorkflow('in_progress')">
                  <span class="stat-number">{{ inProgressCount }}</span>
                  <span class="stat-label">En cours de traitement</span>
                </div>
                <div class="stat-item stat-refused" :class="{ active: filters.workflow_status === 'refuse' }" @click="filterByWorkflow('refuse')">
                  <span class="stat-number">{{ refusedCount }}</span>
                  <span class="stat-label">Refusés</span>
                </div>
                <div class="stat-item stat-archived" :class="{ active: filters.workflow_status === 'archive' }" @click="filterByWorkflow('archive')">
                  <span class="stat-number">{{ archivedCount }}</span>
                  <span class="stat-label">Archivés</span>
                </div>
              </div>
              <!-- Boutons d'action (admin/gestion) -->
              <div v-if="canManageCompanies" class="ops-actions">
                <button class="btn-manage" style="width: 100%;" @click="showDocTypeModal = true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z"/>
                  </svg>
                  Gérer les types de document
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtres -->
    <div class="filters container-fluid">
      <div class="search">
        <input 
          v-model="searchTerm" 
          @input="debouncedSearch" 
          type="text" 
          placeholder="Rechercher un document..."
          class="search-input"
        >
        <select v-model="filters.company_id" @change="onFilterChange">
          <option value="">Toutes les entreprises</option>
          <option value="-1">— Sans entreprise —</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>
        <select v-if="!isTypeRestricted" v-model="filters.document_type_id" @change="onFilterChange">
          <option value="">Tous les types</option>
          <option v-for="type in documentTypes" :key="type.id" :value="type.id">
            {{ type.name }}
          </option>
        </select>
        <span v-else class="badge-type-locked">{{ restrictedTypeLabel }}</span>
        <select v-model="filters.workflow_status" @change="onFilterChange">
          <option v-for="option in workflowStatusOptions" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <select v-model="filters.period" @change="onFilterChange" class="select-period">
          <option value="">Toutes périodes</option>
          <option value="aujourd_hui">Aujourd'hui</option>
          <option value="hier">Hier</option>
          <option value="semaine_cours">Semaine en cours</option>
          <option value="semaine_precedente">Semaine précédente</option>
          <option value="mois_cours">Mois en cours</option>
          <option value="mois_precedent">Mois précédent</option>
          <option value="mois_suivant">Mois suivant</option>
          <option value="mois_flottant">Mois flottant</option>
          <option value="deux_derniers_mois">Deux derniers mois</option>
          <option value="annee_precedente">Année précédente</option>
          <option value="annee_cours">Année en cours</option>
          <option value="personnalisee">Personnalisée</option>
        </select>
        <template v-if="filters.period === 'personnalisee'">
          <input
            type="date"
            v-model="filters.customDateFrom"
            @change="onFilterChange"
            class="input-date"
            title="Date de début"
          >
          <input
            type="date"
            v-model="filters.customDateTo"
            @change="onFilterChange"
            class="input-date"
            title="Date de fin"
          >
        </template>
        <button class="btn-reset" @click="resetFilters">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
          </svg>
          Réinitialiser
        </button>
        <button v-if="canExport" class="btn-export" @click="exportCSV">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
          </svg>
          Export CSV
        </button>
      </div>
    </div>

    <!-- Tableau des documents -->  
    <div class="table-responsive-modern">
      <table class="documentsListeModern">
        <thead>
          <tr>
            <th>Fichier</th>
            <th v-if="!activeTypeConfig">Type</th>
            <th v-for="col in tableColumns" :key="col.key">{{ col.label }}</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td :colspan="visibleTableColspan" class="text-center">
              <div class="loading-inline">Chargement...</div>
            </td>
          </tr>
          <tr v-else-if="documents.length === 0">
            <td :colspan="visibleTableColspan" class="text-center">Aucun document</td>
          </tr>
          <template v-for="doc in documents" :key="doc.id">
            <tr 
              :id="'doc-row-' + doc.id"
              :class="getRowHighlightClass(doc)"
            >
              <td class="td-file">
                <a :href="getFileUrl(doc.file_path)" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right:5px;">
                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                  </svg>
                  {{ doc.file_name }}
                </a>
                <span v-if="doc.children_count > 0" class="badge-children" @click="toggleChildren(doc.id)">
                  {{ expandedDocs.includes(doc.id) ? '▾' : '▸' }} {{ doc.children_count }} document(s) lié(s){{ doc.children_count > 1 ? 's' : '' }}
                </span>
              </td>
              <td v-if="!activeTypeConfig">
                <span v-if="doc.document_type_name" class="badge-type" :class="getBadgeClass(doc.document_type_code)">
                  {{ doc.document_type_name }}<template v-if="doc.document_type_code === 'bon-de-livraison' && doc.magasin_name"> ({{ doc.magasin_name }})</template>
                </span>
                <span v-else class="badge-type badge-pending">
                  {{ doc.status === 'pending' || doc.status === 'processing' ? 'Détection...' : 'Non déterminé' }}
                </span>

              </td>
              <td v-for="col in visibleTableColumns" :key="col.key" class="td-truncate">
                <strong v-if="col.type === 'money' && getDocFieldValue(doc, col) !== '-'" :title="getDocFieldValue(doc, col)">{{ getDocFieldValue(doc, col) }}</strong>
                <span v-else class="cell-truncate" :title="String(getDocFieldValue(doc, col)).length > 30 ? getDocFieldValue(doc, col) : ''">{{ truncateValue(getDocFieldValue(doc, col)) }}</span>
              </td>
              <td>
                <span class="badge-workflow" :class="getWorkflowBadgeClass(doc.workflow_status)">
                  {{ formatWorkflowStatus(doc.workflow_status) }}
                </span>
              </td>
              <td class="actions-cell">
                <button 
                  class="btn-action btn-view" 
                  @click="viewDocument(doc)"
                  title="Voir détails"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                  </svg>
                </button>
                <button
                  v-if="doc.file_path"
                  class="btn-action btn-open-pdf"
                  title="Ouvrir le fichier"
                  @click="openFile(doc.file_path)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                    <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>
                  </svg>
                </button>
                <button 
                  v-if="canDelete"
                  class="btn-action btn-delete" 
                  @click="deleteDocument(doc)"
                  title="Supprimer"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                  </svg>
                </button>
              </td>
            </tr>
            <!-- Lignes enfants (fusionnées) -->
            <template v-if="expandedDocs.includes(doc.id) && doc._children">
            <tr v-for="child in doc._children" :key="'child-' + child.id" class="row-child">
              <td class="td-child-indent">
                <span class="child-connector">└</span>
                <a :href="getFileUrl(child.file_path)" target="_blank">{{ child.file_name }}</a>
              </td>
              <td v-if="!activeTypeConfig">
                <span v-if="child.document_type_name" class="badge-type badge-sm" :class="getBadgeClass(child.document_type_code)">
                  {{ child.document_type_name }}<template v-if="child.document_type_code === 'bon-de-livraison' && child.magasin_name"> ({{ child.magasin_name }})</template>
                </span>
              </td>
              <td v-for="col in visibleTableColumns" :key="col.key" class="td-truncate">
                <span class="cell-truncate" :title="String(getDocFieldValue(child, col)).length > 30 ? getDocFieldValue(child, col) : ''">{{ truncateValue(getDocFieldValue(child, col)) }}</span>
              </td>
              <td>
                <span class="badge-workflow badge-sm" :class="getWorkflowBadgeClass(child.workflow_status)">
                  {{ formatWorkflowStatus(child.workflow_status) }}
                </span>
              </td>
              <td class="actions-cell">
                <button class="btn-action btn-view" @click="viewDocument(child)" title="Voir détails">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                  </svg>
                </button>
                <button
                  v-if="child.file_path"
                  class="btn-action btn-open-pdf"
                  title="Ouvrir le fichier"
                  @click="openFile(child.file_path)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                    <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>
                  </svg>
                </button>
              </td>
            </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div v-if="totalPages > 1" class="pagination-container">
      <div class="pagination-info">
        {{ totalDocuments }} document{{ totalDocuments > 1 ? 's' : '' }} — Page {{ currentPage }} / {{ totalPages }}
      </div>
      <div class="pagination-controls">
        <button 
          class="pagination-btn" 
          :disabled="currentPage <= 1"
          @click="previousPage"
          title="Page précédente"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          </svg>
        </button>
        <template v-for="page in paginationPages()" :key="'page-' + page">
          <span v-if="page === '...'" class="pagination-ellipsis">...</span>
          <button 
            v-else
            class="pagination-btn" 
            :class="{ active: page === currentPage }"
            @click="goToPage(page)"
          >
            {{ page }}
          </button>
        </template>
        <button 
          class="pagination-btn" 
          :disabled="currentPage >= totalPages"
          @click="nextPage"
          title="Page suivante"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal détails avec édition -->
    <div v-if="selectedDocument" class="popup" @click.self="closeDetailModal">
      <div class="popup-content popup-xl">
        <div class="popup-header">
          <h2>{{ isEditing ? 'Modifier le document' : 'Détails du document' }}</h2>
          <a class="close-button" @click="closeDetailModal">&times;</a>
        </div>
        <div class="popup-body">
          <!-- WORKFLOW -->
          <div class="workflow-section" v-if="!isEditing" :class="'wf-status-' + getStatusColor(selectedDocument.workflow_status)">

            <!-- Ligne principale : statut + magasin -->
            <div class="wf-top">

              <!-- Statut + sous-titre contextuel -->
              <div class="wf-status-group">
                <span class="wf-section-label">Statut</span>
                <div class="wf-status-row">
                  <span class="badge-workflow badge-lg" :class="getWorkflowBadgeClass(selectedDocument.workflow_status)">
                    {{ formatWorkflowStatus(selectedDocument.workflow_status) }}
                  </span>
                  <svg v-if="isDocumentArchived" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#6c757d" viewBox="0 0 16 16" title="Document archivé (lecture seule)">
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                  </svg>
                </div>
                <!-- Sous-titre selon le statut -->
                <p class="wf-subtitle"
                  v-if="isValidatedStatus(selectedDocument.workflow_status) && selectedDocument.validated_at">
                  Validé par {{ selectedDocument.validated_by_name || 'Inconnu' }}&nbsp;·&nbsp;{{ formatDateTime(selectedDocument.validated_at) }}
                </p>
                <p class="wf-subtitle wf-subtitle-danger"
                  v-else-if="selectedDocument.workflow_status === 'refuse' && selectedDocument.validated_by_name">
                  Refusé par {{ selectedDocument.validated_by_name }}<span v-if="selectedDocument.validated_at">&nbsp;·&nbsp;{{ formatDateTime(selectedDocument.validated_at) }}</span>
                </p>
                <p class="wf-subtitle wf-subtitle-archive"
                  v-else-if="selectedDocument.workflow_status === 'archive'">
                  <span v-if="selectedDocument.archived_by_name">Archivé par {{ selectedDocument.archived_by_name }}<span v-if="selectedDocument.archived_at">&nbsp;·&nbsp;{{ formatDateTime(selectedDocument.archived_at) }}</span></span>
                  <span v-else>Document archivé — accès lecture seule</span>
                </p>
                <p class="wf-subtitle wf-subtitle-warning"
                  v-else-if="selectedDocument.workflow_status === 'facture_bloquee_gpao'">
                  En attente de validation GPAO du BL lié
                </p>
                <p class="wf-subtitle"
                  v-else-if="!selectedDocument.workflow_status || selectedDocument.workflow_status === 'en_attente'">
                  Reçu le {{ formatDateTime(selectedDocument.created_at) }}
                </p>
                <p class="wf-subtitle" v-else-if="isDocumentModified(selectedDocument)">
                  Modifié le {{ formatDateTime(selectedDocument.updated_at) }}
                </p>
              </div>

              <!-- Magasin (BL uniquement) -->
              <div v-if="selectedDocument.document_type_code === 'bon-de-livraison'" class="wf-magasin">
                <span class="wf-section-label">Magasin</span>
                <select
                  v-if="canEditMetadata && (!selectedDocument.workflow_status || selectedDocument.workflow_status === 'en_attente')"
                  class="select-magasin-inline"
                  :value="selectedDocument.magasin_id || 1"
                  @change="assignMagasin($event.target.value)"
                >
                  <option value="">— Aucun —</option>
                  <option v-for="mag in magasins" :key="mag.id_magasins" :value="mag.id_magasins">{{ mag.nom_magasins }}</option>
                </select>
                <span v-else class="badge-magasin">{{ selectedDocument.magasin_name || 'Non défini' }}</span>
              </div>

            </div>

            <!-- Barre d'actions -->
            <div class="wf-actions-bar">
              <button
                v-if="canEditMetadata"
                class="btn-wf btn-wf-edit"
                @click="startEditing"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
                Modifier
              </button>
              <button
                v-for="transition in availableTransitions"
                :key="transition.status"
                class="btn-wf"
                :class="'btn-wf-' + transition.color"
                @click="updateWorkflowStatus(transition.status)"
                :disabled="isUpdatingStatus"
              >
                {{ transition.label }}
              </button>
              <span v-if="!canEditMetadata && availableTransitions.length === 0" class="wf-no-actions">
                Aucune action disponible
              </span>
            </div>

          </div>
          <div class="row">
            
            <!-- Informations du document -->
            <div class="col-md-12">
              <div class="row">
                <!-- INFORMATIONS GÉNÉRALES (tous types) -->
                <div :class="(canViewFinancial && hasFinancialData && !selectedDocDetailFields) ? 'col-md-6' : 'col-md-12'">
                  <h3>Informations {{ selectedDocument.document_type_name || 'du document' }}</h3>
                  <table class="table-details" v-if="!isEditing">
                    <tr>
                      <th>Type</th>
                      <td>
                        <span v-if="selectedDocument.document_type_name" class="badge-type" :class="getBadgeClass(selectedDocument.document_type_code)">
                          {{ selectedDocument.document_type_name }}<template v-if="selectedDocument.document_type_code === 'bon-de-livraison' && selectedDocument.magasin_name"> ({{ selectedDocument.magasin_name }})</template>
                        </span>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <tr v-if="selectedDocument.document_category">
                      <th>Catégorie</th>
                      <td>{{ formatCategory(selectedDocument.document_category) }}</td>
                    </tr>
                    <tr v-if="selectedDocument.company_name">
                      <th>Entreprise</th>
                      <td>{{ selectedDocument.company_name }}</td>
                    </tr>
                    <tr v-if="selectedDocument.document_type_code === 'bon-de-livraison' && selectedDocument.magasin_name">
                      <th>Magasin</th>
                      <td>{{ selectedDocument.magasin_name }}</td>
                    </tr>
                    <!-- Mode dynamique : afficher les champs du type -->
                    <template v-if="selectedDocDetailFields">
                      <tr v-for="col in selectedDocDetailFields" :key="col.key">
                        <th>{{ col.label }}</th>
                        <td>
                          <strong v-if="col.type === 'money' && getDocFieldValue(selectedDocument, col) !== '-'">{{ getDocFieldValue(selectedDocument, col) }}</strong>
                          <span v-else>{{ getDocFieldValue(selectedDocument, col) }}</span>
                        </td>
                      </tr>
                    </template>
                    <!-- Mode par défaut : champs génériques -->
                    <template v-else>
                      <tr>
                        <th>N° Document</th>
                        <td>{{ selectedDocument.document_number || '-' }}</td>
                      </tr>
                      <tr>
                        <th>Date</th>
                        <td>{{ formatDate(selectedDocument.document_date) }}</td>
                      </tr>
                      <tr v-if="selectedDocument.supplier_name">
                        <th>Émetteur</th>
                        <td>{{ selectedDocument.supplier_name }}</td>
                      </tr>
                      <tr v-if="selectedDocument.recipient_name">
                        <th>Destinataire</th>
                        <td>{{ selectedDocument.recipient_name }}</td>
                      </tr>
                      <tr v-if="selectedDocument.order_number">
                        <th>N° Commande</th>
                        <td>{{ selectedDocument.order_number }}</td>
                      </tr>
                      <tr v-if="selectedDocument.due_date">
                        <th>Échéance</th>
                        <td>{{ formatDate(selectedDocument.due_date) }}</td>
                      </tr>
                      <tr v-if="selectedDocument.payment_method">
                        <th>Mode paiement</th>
                        <td>{{ selectedDocument.payment_method }}</td>
                      </tr>
                    </template>
                  </table>
                  <div v-else class="edit-form">
                    <div class="form-group">
                      <label>Entreprise</label>
                      <select v-model="editForm.company_id">
                        <option value="">— Non définie —</option>
                        <option v-for="company in companies" :key="company.id" :value="company.id">{{ company.name }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Type de document</label>
                      <select v-model="editForm.document_type_id">
                        <option value="">— Non défini —</option>
                        <option v-for="type in documentTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                      </select>
                    </div>
                    <div v-if="selectedDocument.document_type_code === 'bon-de-livraison'" class="form-group">
                      <label>Magasin</label>
                      <select v-model="editForm.magasin_id">
                        <option value="">— Non défini —</option>
                        <option v-for="mag in magasins" :key="mag.id_magasins" :value="mag.id_magasins">{{ mag.nom_magasins }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>N° Document</label>
                      <input type="text" v-model="editForm.document_number" />
                    </div>
                    <div class="form-group">
                      <label>N° Commande</label>
                      <input type="text" v-model="editForm.order_number" />
                    </div>
                    <div class="form-group">
                      <label>Date</label>
                      <input type="date" v-model="editForm.document_date" />
                    </div>
                    <div class="form-group" v-if="hasFinancialData">
                      <label>Échéance</label>
                      <input type="date" v-model="editForm.due_date" />
                    </div>
                    <div class="form-group" v-if="hasFinancialData">
                      <label>Mode paiement</label>
                      <input type="text" v-model="editForm.payment_method" />
                    </div>
                  </div>
                </div>

                <!-- MONTANTS (uniquement catégorie financier, masqué si champs dynamiques) -->
                <div v-if="canViewFinancial && hasFinancialData && !selectedDocDetailFields" class="col-md-6">
                  <h3>Montants</h3>
                  <table class="table-details" v-if="!isEditing">
                    <tr>
                      <th>Total HT</th>
                      <td>{{ formatMoney(selectedDocument.total_ht) }}</td>
                    </tr>
                    <tr>
                      <th>Total TVA</th>
                      <td>{{ formatMoney(selectedDocument.total_tva) }}</td>
                    </tr>
                    <tr class="row-highlight">
                      <th>Total TTC</th>
                      <td><strong>{{ formatMoney(selectedDocument.total_ttc) }}</strong></td>
                    </tr>
                  </table>
                  <div v-else class="edit-form">
                    <div class="form-group">
                      <label>Total HT (€)</label>
                      <input type="number" step="0.01" v-model="editForm.total_ht" />
                    </div>
                    <div class="form-group">
                      <label>Total TVA (€)</label>
                      <input type="number" step="0.01" v-model="editForm.total_tva" />
                    </div>
                    <div class="form-group">
                      <label>Total TTC (€)</label>
                      <input type="number" step="0.01" v-model="editForm.total_ttc" />
                    </div>
                  </div>
                </div>

                <!-- CHAMPS SPÉCIFIQUES EXTRAITS (masqué si champs dynamiques) -->
                <div v-if="hasExtractedFields && !selectedDocDetailFields" class="col-md-12 mt-3">
                  <h3>Informations spécifiques</h3>
                  <table class="table-details">
                    <tr v-for="(value, key) in selectedDocument.extracted_fields" :key="key">
                      <th>{{ formatFieldKey(key) }}</th>
                      <td>
                        <template v-if="Array.isArray(value)">
                          <ul class="extracted-list" v-if="value.length > 0 && typeof value[0] === 'object'">
                            <li v-for="(item, idx) in value" :key="idx">
                              <span v-for="(val, k) in item" :key="k">{{ formatFieldKey(k) }}: {{ val }} &nbsp;</span>
                            </li>
                          </ul>
                          <span v-else>{{ value.join(', ') }}</span>
                        </template>
                        <template v-else>{{ value || '-' }}</template>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <h3 v-if="hasLines" class="mt-4">{{ linesTitle }}</h3>
              <div v-if="hasLines" class="table-responsive-modern">
                <!-- MODE ÉDITION -->
                <div v-if="isEditing" class="lines-edit-section">
                  <div v-for="(line, idx) in editForm.lines" :key="idx" class="line-edit-row">
                    <div class="line-number">#{{ idx + 1 }}</div>
                    <input v-model="line.reference" placeholder="Référence" class="line-input" />
                    <input v-model="line.description" placeholder="Description" class="line-input line-input-wide" />
                    <input v-model="line.quantity" type="number" step="0.01" placeholder="Qté" class="line-input line-input-sm" />
                    <input v-model="line.unit" placeholder="U" class="line-input line-input-xs" />
                    <input v-if="hasFinancialData" v-model="line.unit_price" type="number" step="0.01" placeholder="P.U. HT" class="line-input line-input-sm" />
                    <input v-if="hasFinancialData" v-model="line.total_ht" type="number" step="0.01" placeholder="Total HT" class="line-input line-input-sm" />
                    <input v-if="hasFinancialData" v-model="line.tva_rate" type="number" step="0.01" placeholder="TVA %" class="line-input line-input-xs" />
                  </div>
                </div>

                <!-- MODE LECTURE -->
                <div v-else>
                  <!-- LIGNES AVEC PRIX (financier) -->
                  <table v-if="hasFinancialData" class="documentsListeModern">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Référence</th>
                        <th>Description</th>
                        <th>Qté</th>
                        <th>P.U. HT</th>
                        <th>Total HT</th>
                        <th>TVA %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="line in selectedDocument.lines" :key="line.id">
                        <td>{{ line.line_number }}</td>
                        <td>{{ line.reference || '-' }}</td>
                        <td>{{ line.description }}</td>
                        <td>{{ line.quantity != null && line.quantity !== '' ? line.quantity : '' }}{{ line.unit ? ' ' + line.unit : '' }}</td>
                        <td>{{ line.unit_price != null && line.unit_price !== '' ? formatMoney(line.unit_price) : '-' }}</td>
                        <td>{{ line.total_ht != null && line.total_ht !== '' ? formatMoney(line.total_ht) : '-' }}</td>
                        <td>{{ line.tva_rate != null && line.tva_rate !== '' ? line.tva_rate + '%' : '-' }}</td>
                      </tr>
                      <tr v-if="!selectedDocument.lines || selectedDocument.lines.length === 0">
                        <td colspan="7" class="text-center">Aucune ligne</td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- LIGNES SANS PRIX (livraison, etc.) -->
                  <table v-else class="documentsListeModern">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Référence</th>
                        <th>Description</th>
                        <th>Quantité</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="line in selectedDocument.lines" :key="line.id">
                        <td>{{ line.line_number }}</td>
                        <td>{{ line.reference || '-' }}</td>
                        <td>{{ line.description }}</td>
                        <td>{{ line.quantity != null && line.quantity !== '' ? line.quantity : '' }}{{ line.unit ? ' ' + line.unit : '' }}</td>
                      </tr>
                      <tr v-if="!selectedDocument.lines || selectedDocument.lines.length === 0">
                        <td colspan="4" class="text-center">Aucune ligne</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- SECTION DOCUMENTS LIÉS -->
              <div class="linked-docs-section mt-4" v-if="!isEditing">
                <div class="linked-docs-header">
                  <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                    </svg>
                    Documents liés ({{ (selectedDocument.linked_documents || []).length }})
                  </h3>
                  <button v-if="canLink" class="btn-link-add" @click="openLinkModal(selectedDocument)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Lier des documents
                  </button>
                </div>
                <div v-if="selectedDocument.linked_documents && selectedDocument.linked_documents.length > 0" class="linked-docs-list">
                  <div v-for="ldoc in selectedDocument.linked_documents" :key="ldoc.id" class="linked-doc-item">
                    <div class="linked-doc-info">
                      <span v-if="ldoc.document_type_name" class="badge-type badge-sm" :class="getBadgeClass(ldoc.document_type_code)">
                        {{ ldoc.document_type_name }}
                      </span>
                      <a :href="getFileUrl(ldoc.file_path)" target="_blank" class="linked-doc-name">{{ ldoc.file_name }}</a>
                      <span class="linked-doc-number">{{ ldoc.document_number || '' }}</span>
                      <span class="linked-doc-date">{{ formatDate(ldoc.document_date) }}</span>
                      <span v-if="ldoc.total_ttc && canViewFinancial" class="linked-doc-amount">{{ formatMoney(ldoc.total_ttc) }}</span>
                    </div>
                    <div class="linked-doc-actions">
                      <button class="btn-action btn-view" @click="viewDocument(ldoc)" title="Voir ce document">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg>
                      </button>
                      <button v-if="canLink" class="btn-action btn-delete" @click="unlinkDocument(selectedDocument.id, ldoc.id)" title="Délier">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="linked-docs-empty">
                  Aucun document lié. Cliquez sur "Lier des documents" pour en ajouter.
                </div>
              </div>

              <!-- HISTORIQUE / TIMELINE -->
              <div class="history-section mt-4" v-if="selectedDocument.history && selectedDocument.history.length > 0 && !isEditing">
                <h3>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
                  </svg>
                  Historique
                </h3>
                <div class="timeline">
                  <div v-for="event in selectedDocument.history" :key="event.id" class="timeline-item">
                    <div class="timeline-dot" :class="getTimelineDotClass(event)"></div>
                    <div class="timeline-content">
                      <div class="timeline-label">
                        {{ event.label }}
                        <!-- Transition old → new si disponible -->
                        <span v-if="event.old_status && event.new_status" class="timeline-transition">
                          <span class="badge-workflow badge-xs" :class="getWorkflowBadgeClass(event.old_status)">{{ formatWorkflowStatus(event.old_status) }}</span>
                          <span class="transition-arrow">→</span>
                          <span class="badge-workflow badge-xs" :class="getWorkflowBadgeClass(event.new_status)">{{ formatWorkflowStatus(event.new_status) }}</span>
                        </span>
                      </div>
                      <div class="timeline-meta">
                        {{ formatDateTime(event.created_at) }}
                        <span v-if="event.user_name"> — {{ event.user_name }}</span>
                        <span v-if="event.user_role" class="timeline-role">({{ event.user_role }})</span>
                      </div>
                      <div v-if="event.commentaire" class="timeline-comment">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12z"/>
                        </svg>
                        {{ event.commentaire }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Boutons d'action (mode édition uniquement) -->
              <div v-if="isEditing" class="popup-actions mt-4">
                <div class="action-buttons">
                  <button class="btn-secondary" @click="cancelEditing">Annuler</button>
                  <button class="btn-save" @click="saveDocument" :disabled="isSaving">
                    {{ isSaving ? 'Enregistrement...' : 'Enregistrer' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal liaison documents (multi-sélection) -->
    <div v-if="showLinkModal" class="popup" @click.self="showLinkModal = false">
      <div class="popup-content popup-link">
        <div class="popup-header">
          <h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
              <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
              <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
            </svg>
            Lier des documents
          </h2>
          <a class="close-button" @click="showLinkModal = false">&times;</a>
        </div>
        <div class="popup-body">
          <!-- Contexte -->
          <div class="link-modal-context">
            <span class="link-modal-context-label">Document source&nbsp;:</span>
            <span class="badge-type" :class="getBadgeClass(documentToLink?.document_type_code)">
              {{ documentToLink?.document_type_name || 'Document' }}
            </span>
            <span class="link-modal-context-name">{{ documentToLink?.file_name }}</span>
          </div>

          <!-- Recherche -->
          <div class="link-modal-search">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.099zm-5.242 1.656a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/>
            </svg>
            <input
              type="text"
              v-model="linkSearch"
              placeholder="Rechercher par nom, numéro, entreprise…"
              @input="debouncedLinkSearch"
              autofocus
            />
          </div>

          <!-- Liste -->
          <div class="linkable-documents">
            <div
              v-for="doc in linkableDocuments"
              :key="doc.id"
              class="linkable-doc-item"
              :class="{ 'selected': selectedLinkDocuments.includes(doc.id) }"
              @click="toggleLinkSelection(doc.id)"
            >
              <div class="ldi-check">
                <span class="ldi-checkbox" :class="{ 'checked': selectedLinkDocuments.includes(doc.id) }">
                  <svg v-if="selectedLinkDocuments.includes(doc.id)" xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </span>
              </div>
              <div class="ldi-body">
                <div class="ldi-top">
                  <span v-if="doc.document_type_name" class="badge-type badge-sm" :class="getBadgeClass(doc.document_type_code)">
                    {{ doc.document_type_name }}
                  </span>
                  <span class="ldi-name">{{ doc.file_name }}</span>
                </div>
                <div class="ldi-meta">
                  <span v-if="doc.document_number" class="ldi-number">{{ doc.document_number }}</span>
                  <span v-if="doc.company_name" class="ldi-company">{{ doc.company_name }}</span>
                  <span v-if="doc.document_date" class="ldi-date">{{ formatDate(doc.document_date) }}</span>
                  <span v-if="doc.total_ttc" class="ldi-amount">{{ formatMoney(doc.total_ttc) }}</span>
                </div>
              </div>
              <span class="badge-workflow badge-sm" :class="getWorkflowBadgeClass(doc.workflow_status)">
                {{ formatWorkflowStatus(doc.workflow_status) }}
              </span>
            </div>
            <div v-if="linkableDocuments.length === 0" class="link-modal-empty">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
              <span>Aucun document disponible</span>
            </div>
          </div>

          <!-- Footer -->
          <div class="link-modal-footer">
            <span class="link-modal-count" v-if="selectedLinkDocuments.length > 0">
              {{ selectedLinkDocuments.length }} document{{ selectedLinkDocuments.length > 1 ? 's' : '' }} sélectionné{{ selectedLinkDocuments.length > 1 ? 's' : '' }}
            </span>
            <span class="link-modal-count empty" v-else>Aucune sélection</span>
            <div class="link-modal-actions">
              <button class="btn-secondary" @click="showLinkModal = false">Annuler</button>
              <button
                class="btn-save"
                @click="linkDocuments"
                :disabled="selectedLinkDocuments.length === 0 || isLinking"
              >
                <svg v-if="!isLinking" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                </svg>
                {{ isLinking ? 'Liaison en cours…' : 'Lier' + (selectedLinkDocuments.length > 0 ? ' (' + selectedLinkDocuments.length + ')' : '') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup gestion des types de document -->
    <div v-if="showDocTypeModal && canManageCompanies" class="popup" @click.self="showDocTypeModal = false">
      <div class="popup-content popup-lg">
        <div class="popup-header">
          <h2>Gestion des types de document</h2>
          <a class="close-button" @click="showDocTypeModal = false">&times;</a>
        </div>
        <div class="popup-body">
          <!-- Formulaire d'ajout -->
          <div class="popup-section">
            <h3>Ajouter un type de document</h3>
            <div class="form-group">
              <label>Nom du type *</label>
              <div class="input-with-btn">
                <input 
                  v-model="newDocType.name" 
                  type="text" 
                  placeholder="Ex: Bon de commande"
                  @keyup.enter="addDocumentType"
                />
                <button 
                  class="btn-add" 
                  @click="addDocumentType"
                  :disabled="!newDocType.name || isSavingDocType"
                >
                  <span v-if="isSavingDocType">Ajout...</span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Ajouter
                  </span>
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>Code (optionnel, auto-généré si vide)</label>
              <input 
                v-model="newDocType.code" 
                type="text" 
                placeholder="Ex: bon-de-commande"
              />
            </div>
            <div class="form-group">
              <label>Description (optionnel)</label>
              <input 
                v-model="newDocType.description" 
                type="text" 
                placeholder="Description du type de document"
              />
            </div>
          </div>
          
          <!-- Liste des types -->
          <div class="popup-section">
            <h3>Types de document existants ({{ documentTypes.length }})</h3>
            <div v-if="documentTypes.length === 0" class="empty-state">
              Aucun type de document enregistré
            </div>
            <div v-else class="table-responsive-modern">
              <table class="documentsListeModern">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="dtype in documentTypes" :key="dtype.id">
                    <td>{{ dtype.name }}</td>
                    <td><code>{{ dtype.code }}</code></td>
                    <td>{{ dtype.description || '—' }}</td>
                    <td class="actions-cell">
                      <button
                        class="btn-action btn-delete"
                        @click="deleteDocumentType(dtype)"
                        title="Supprimer ce type"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                          <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global Swal */
import axios from '../../components/axiosConfig';
import VueCookies from 'vue-cookies';
import { hasPermission, getAvailableTransitions, getStatusLabel, getStatusColor, getRestrictedTypeCode, BL_TYPE_CODE, FACTURE_TYPE_CODE } from '../../config/scanDocPermissions';

export default {
  name: 'ScanDocumentsView',
  data() {
    return {
      userRole: null,
      companies: [],
      documentTypes: [],
      magasins: [],
      documents: [],
      filters: {
        company_id: '',
        document_type_id: '',
        workflow_status: '',
        period: '',
        customDateFrom: '',
        customDateTo: ''
      },
      searchTerm: '',
      searchTimeout: null,
      selectedFiles: [],
      selectedDocument: null,
      isDragging: false,
      isUploading: false,
      isLoading: false,
      uploadProgress: {
        current: 0,
        total: 0,
        currentFile: '',
        results: []
      },
      // Types de document
      showDocTypeModal: false,
      newDocType: { name: '', code: '', description: '' },
      isSavingDocType: false,

      // Édition document
      isEditing: false,
      editForm: {},
      isSaving: false,
      // Liaison documents
      showLinkModal: false,
      documentToLink: null,
      linkableDocuments: [],
      selectedLinkDocuments: [],
      linkSearch: '',
      linkSearchTimeout: null,
      isLinking: false,
      // Workflow
      isUpdatingStatus: false,
      expandedDocs: [],
      // Surbrillance
      highlightedDocId: null,
      // Pagination
      currentPage: 1,
      perPage: 10,
      totalDocuments: 0,
      totalPages: 0,
      pendingCount: 0,
      inProgressCount: 0,
      refusedCount: 0,
      archivedCount: 0,
      blockedCount: 0
    };
  },
  computed: {
    completedCount() {
      return this.documents.filter(d => d.status === 'completed').length;
    },
    selectedDocCategory() {
      if (!this.selectedDocument) return null;
      return this.selectedDocument.document_category || null;
    },
    hasFinancialData() {
      if (!this.selectedDocument) return false;
      const cat = this.selectedDocument.document_category;
      // Considérer financier si catégorie financier, ou si des montants existent
      return cat === 'financier' || 
        (this.selectedDocument.total_ht !== null && this.selectedDocument.total_ht !== undefined && this.selectedDocument.total_ht !== '') ||
        (this.selectedDocument.total_ttc !== null && this.selectedDocument.total_ttc !== undefined && this.selectedDocument.total_ttc !== '');
    },
    hasLines() {
      if (!this.selectedDocument) return false;
      return this.selectedDocument.lines && this.selectedDocument.lines.length > 0;
    },
    hasExtractedFields() {
      if (!this.selectedDocument) return false;
      const ef = this.selectedDocument.extracted_fields;
      return ef && typeof ef === 'object' && Object.keys(ef).length > 0;
    },
    linesTitle() {
      if (!this.selectedDocument) return 'Lignes';
      const cat = this.selectedDocument.document_category;
      if (cat === 'livraison') return 'Articles livrés';
      if (cat === 'financier') return 'Lignes du document';
      return 'Détail des lignes';
    },
    activeTypeConfig() {
      if (!this.filters.document_type_id) return null;
      const t = this.documentTypes.find(t => t.id == this.filters.document_type_id);
      return (t && t.display_fields && t.display_fields.length > 0) ? t : null;
    },
    selectedDocDetailFields() {
      if (!this.selectedDocument) return null;
      const typeId = this.selectedDocument.document_type_id;
      if (!typeId) return null;
      const t = this.documentTypes.find(t => t.id == typeId);
      return (t && t.display_fields && t.display_fields.length > 0) ? t.display_fields : null;
    },
    tableColumns() {
      if (this.activeTypeConfig) {
        return this.activeTypeConfig.display_fields;
      }
      return [
        { key: 'company_name', label: 'Entreprise' },
        { key: 'document_number', label: 'N° Document' },
        { key: 'document_date', label: 'Date', type: 'date' },
        { key: 'total_ht', label: 'Total HT', type: 'money' },
        { key: 'total_ttc', label: 'Total TTC', type: 'money' }
      ];
    },
    tableColspan() {
      // Fichier + Type + colonnes dynamiques + Statut + Actions
      return this.tableColumns.length + 4;
    },
    // --- Permissions GED ---
    canUpload() {
      return hasPermission(this.userRole, 'upload');
    },
    canEditMetadata() {
      if (!this.selectedDocument) return false;
      // Document archivé → lecture seule
      if (this.selectedDocument.workflow_status === 'archive') return false;
      return hasPermission(this.userRole, 'edit_metadata');
    },
    canDelete() {
      if (!this.selectedDocument) return hasPermission(this.userRole, 'delete_document');
      // Document archivé → pas de suppression
      if (this.selectedDocument.workflow_status === 'archive') return false;
      return hasPermission(this.userRole, 'delete_document');
    },
    canLink() {
      return hasPermission(this.userRole, 'link_documents');
    },
    canManageCompanies() {
      return hasPermission(this.userRole, 'manage_companies');
    },
    canViewFinancial() {
      return hasPermission(this.userRole, 'view_financial');
    },
    canExport() {
      return hasPermission(this.userRole, 'export_csv');
    },
    // Rôles cantonnés à un seul type de document (BL pour production/be/gestion,
    // facture pour la comptabilité) : le filtre de type est remplacé par un badge figé
    restrictedTypeCode() {
      return getRestrictedTypeCode(this.userRole);
    },
    isTypeRestricted() {
      return this.restrictedTypeCode !== null;
    },
    restrictedTypeLabel() {
      if (this.restrictedTypeCode === FACTURE_TYPE_CODE) return 'Factures';
      if (this.restrictedTypeCode === BL_TYPE_CODE) return 'Bons de livraison';
      return '';
    },
    // Filtre de statut : les statuts propres à un type sont masqués aux rôles
    // cantonnés à un autre type (ils ne ramèneraient aucun document)
    workflowStatusOptions() {
      const options = [
        { value: '', label: 'Tous les statuts' },
        { value: 'en_attente', label: 'En attente' },
        { value: 'in_progress', label: '── En cours de traitement ──' },
        { value: 'en_cours_gpao', label: 'Import BL réception', type: BL_TYPE_CODE },
        { value: 'bl_receptionne', label: 'BL réceptionné', type: BL_TYPE_CODE },
        { value: 'entree_gpao_validee', label: 'BL saisie dans CLIPPER', type: BL_TYPE_CODE },
        { value: 'bl_valide', label: 'BL validé', type: BL_TYPE_CODE },
        { value: 'en_attente_facture', label: 'Facture', type: BL_TYPE_CODE },
        { value: 'facture_recue', label: 'Facture reçue', type: FACTURE_TYPE_CODE },
        { value: 'facture_bloquee_gpao', label: 'Bloquée (GPAO)', type: FACTURE_TYPE_CODE },
        { value: 'facture_conforme', label: 'Conforme achats', type: FACTURE_TYPE_CODE },
        { value: 'facture_validee_compta', label: 'Validée comptabilité', type: FACTURE_TYPE_CODE },
        { value: 'facture_payee', label: 'Payée', type: FACTURE_TYPE_CODE },
        { value: 'valide', label: 'Validé (générique)', type: 'generique' },
        { value: 'refuse', label: 'Refusé' },
        { value: 'archive', label: 'Archivé' }
      ];

      if (!this.restrictedTypeCode) return options;
      return options.filter(option => !option.type || option.type === this.restrictedTypeCode);
    },
    // Transitions workflow disponibles pour le document sélectionné
    availableTransitions() {
      if (!this.selectedDocument) return [];
      const typeCode = this.selectedDocument.document_type_code || '';
      const currentStatus = this.selectedDocument.workflow_status || 'en_attente';
      return getAvailableTransitions(currentStatus, typeCode, this.userRole, {
        magasinId: this.selectedDocument.magasin_id || (typeCode === 'bon-de-livraison' ? 1 : null)
      });
    },
    isDocumentArchived() {
      return this.selectedDocument && this.selectedDocument.workflow_status === 'archive';
    },
    // Colonnes tableau filtrées selon permissions financières
    visibleTableColumns() {
      if (this.canViewFinancial) return this.tableColumns;
      return this.tableColumns.filter(col => col.type !== 'money');
    },
    visibleTableColspan() {
      return this.visibleTableColumns.length + 4;
    }
  },
  mounted() {
    const role = VueCookies.get('role');
    this.userRole = role || 'guest';
    this.loadCompanies();
    this.loadDocumentTypes();
    this.loadMagasins();
    this.loadDocuments();
  },
  methods: {
    // Helpers SweetAlert2 - Toasts
    showSuccess(message) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
    },
    showError(message) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: message,
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true
      });
    },
    showInfo(message) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
    },
    formatCategory(cat) {
      const labels = {
        'financier': 'Financier',
        'livraison': 'Livraison',
        'juridique': 'Juridique',
        'rh': 'Ressources humaines',
        'administratif': 'Administratif',
        'general': 'Général'
      };
      return labels[cat] || cat || '-';
    },
    getDocFieldValue(doc, col) {
      const key = col.key;
      let val = null;
      if (key.startsWith('extracted_fields.')) {
        const subKey = key.substring('extracted_fields.'.length);
        const ef = doc.extracted_fields;
        if (ef && typeof ef === 'object') {
          val = ef[subKey] ?? null;
          // Fallback pour anciennes clés IA (documents déjà traités)
          if (val === null || val === undefined || val === '') {
            const fallbacks = {
              'nom': ['nom_complet', 'name', 'prenom_nom'],
              'poste': ['titre_poste', 'poste_recherche', 'titre'],
              'experience': ['experiences'],
              'formation': ['formations'],
              'employe': ['employe_nom', 'nom_employe', 'salarie'],
            };
            if (fallbacks[subKey]) {
              for (const alt of fallbacks[subKey]) {
                if (ef[alt] !== null && ef[alt] !== undefined && ef[alt] !== '') {
                  val = ef[alt];
                  // Si c'est un tableau/objet, le convertir en texte lisible
                  if (Array.isArray(val)) {
                    val = val.map(v => typeof v === 'object' ? Object.values(v).join(' - ') : v).join(', ');
                  }
                  break;
                }
              }
            }
          }
          // Si la valeur est encore un tableau/objet, la rendre lisible
          if (val && typeof val === 'object') {
            if (Array.isArray(val)) {
              val = val.map(v => typeof v === 'object' ? Object.values(v).join(' - ') : v).join(', ');
            } else {
              val = Object.values(val).join(', ');
            }
          }
        }
      } else {
        val = doc[key] ?? null;
      }
      if (val === null || val === undefined || val === '') return '-';
      if (col.type === 'money') return this.formatMoney(val);
      if (col.type === 'date') return this.formatDate(val);
      return String(val);
    },
    truncateValue(val, maxLen = 40) {
      if (!val || val === '-') return val;
      const s = String(val);
      if (s.length <= maxLen) return s;
      return s.substring(0, maxLen) + '…';
    },
    formatFieldKey(key) {
      return key
        .replace(/_/g, ' ')
        .replace(/^\w/, c => c.toUpperCase());
    },
    getBadgeClass(typeCode) {
      const map = {
        'facture': 'badge-facture',
        'bon-de-livraison': 'badge-livraison',
        'bon-de-fourniture-client': 'badge-fourniture-client',
        'devis': 'badge-devis',
        'avoir': 'badge-avoir',
        'contrat': 'badge-contrat',
        'assurance': 'badge-contrat',
        'cv': 'badge-rh',
        'bulletin-de-paie': 'badge-rh',
        'bon-de-commande': 'badge-commande',
        'releve-bancaire': 'badge-financier',
        'attestation': 'badge-admin'
      };
      return map[typeCode] || 'badge-other';
    },
    async loadCompanies() {
      try {
        const response = await axios.get('/api/scan-document/getCompanies.php');
        if (response.data.success) {
          this.companies = response.data.companies;
          console.log('Entreprises chargées:', this.companies.length);
        } else {
          console.error('Erreur API:', response.data.error);
          this.showError('Erreur chargement entreprises: ' + response.data.error);
        }
      } catch (error) {
        console.error('Erreur chargement entreprises:', error);
        this.showError('Erreur chargement entreprises: ' + (error.response?.data?.error || error.message));
      }
    },
    async loadDocumentTypes() {
      try {
        const response = await axios.get('/api/scan-document/getDocumentTypes.php');
        if (response.data.success) {
          this.documentTypes = response.data.types;
          console.log('Types chargés:', this.documentTypes.length);
        } else {
          console.error('Erreur API:', response.data.error);
          this.showError('Erreur chargement types: ' + response.data.error);
        }
      } catch (error) {
        console.error('Erreur chargement types:', error);
        this.showError('Erreur chargement types: ' + (error.response?.data?.error || error.message));
      }
    },
    async loadMagasins() {
      try {
        const response = await axios.get('/api/getMagasins.php');
        this.magasins = response.data || [];
      } catch (error) {
        console.error('Erreur chargement magasins:', error);
      }
    },
    debouncedSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadDocuments();
      }, 300);
    },
    computePeriodDates() {
      const period = this.filters.period;
      if (!period || period === 'personnalisee') return null;
      const now = new Date();
      const y = now.getFullYear();
      const m = now.getMonth();
      const d = now.getDate();
      const fmt = dt => dt.toISOString().slice(0, 10);
      let from, to;
      switch (period) {
        case 'aujourd_hui':
          from = to = fmt(now);
          break;
        case 'hier': {
          const h = new Date(now); h.setDate(d - 1);
          from = to = fmt(h);
          break;
        }
        case 'semaine_cours': {
          const day = now.getDay();
          const diffToMon = day === 0 ? -6 : 1 - day;
          const mon = new Date(now); mon.setDate(d + diffToMon);
          const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
          from = fmt(mon); to = fmt(sun);
          break;
        }
        case 'semaine_precedente': {
          const day = now.getDay();
          const diffToMon = day === 0 ? -6 : 1 - day;
          const mon = new Date(now); mon.setDate(d + diffToMon - 7);
          const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
          from = fmt(mon); to = fmt(sun);
          break;
        }
        case 'mois_cours':
          from = fmt(new Date(y, m, 1));
          to = fmt(new Date(y, m + 1, 0));
          break;
        case 'mois_precedent':
          from = fmt(new Date(y, m - 1, 1));
          to = fmt(new Date(y, m, 0));
          break;
        case 'mois_suivant':
          from = fmt(new Date(y, m + 1, 1));
          to = fmt(new Date(y, m + 2, 0));
          break;
        case 'mois_flottant': {
          const f = new Date(now); f.setDate(d - 30);
          from = fmt(f); to = fmt(now);
          break;
        }
        case 'deux_derniers_mois':
          from = fmt(new Date(y, m - 2, 1));
          to = fmt(new Date(y, m, 0));
          break;
        case 'annee_precedente':
          from = fmt(new Date(y - 1, 0, 1));
          to = fmt(new Date(y - 1, 11, 31));
          break;
        case 'annee_cours':
          from = fmt(new Date(y, 0, 1));
          to = fmt(new Date(y, 11, 31));
          break;
      }
      return from && to ? { from, to } : null;
    },
    resetFilters() {
      this.searchTerm = '';
      this.filters.company_id = '';
      this.filters.document_type_id = '';
      this.filters.workflow_status = '';
      this.filters.period = '';
      this.filters.customDateFrom = '';
      this.filters.customDateTo = '';
      this.currentPage = 1;
      this.loadDocuments();
    },
    onFilterChange() {
      this.currentPage = 1;
      this.loadDocuments();
    },
    filterByWorkflow(status) {
      // Toggle : re-cliquer désactive le filtre
      this.filters.workflow_status = this.filters.workflow_status === status ? '' : status;
      this.currentPage = 1;
      this.loadDocuments();
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.currentPage = page;
      this.loadDocuments();
    },
    previousPage() {
      this.goToPage(this.currentPage - 1);
    },
    nextPage() {
      this.goToPage(this.currentPage + 1);
    },
    paginationPages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        pages.push(1);
        if (current > 3) pages.push('...');
        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (current < total - 2) pages.push('...');
        pages.push(total);
      }
      return pages;
    },
    async loadDocuments() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams();
        if (this.filters.company_id) params.append('company_id', this.filters.company_id);
        if (this.filters.document_type_id) params.append('document_type_id', this.filters.document_type_id);
        if (this.filters.workflow_status) params.append('workflow_status', this.filters.workflow_status);
        if (this.searchTerm) params.append('search', this.searchTerm);
        if (this.filters.period === 'personnalisee') {
          if (this.filters.customDateFrom) params.append('date_from', this.filters.customDateFrom);
          if (this.filters.customDateTo) params.append('date_to', this.filters.customDateTo);
        } else {
          const dates = this.computePeriodDates();
          if (dates) {
            params.append('date_from', dates.from);
            params.append('date_to', dates.to);
          }
        }

        // Pagination
        params.append('page', this.currentPage);
        params.append('per_page', this.perPage);

        const response = await axios.get('/api/scan-document/getDocuments.php?' + params.toString());
        if (response.data.success) {
          this.documents = response.data.documents;
          if (response.data.pagination) {
            this.currentPage = response.data.pagination.page;
            this.totalDocuments = response.data.pagination.total;
            this.totalPages = response.data.pagination.total_pages;
          }
          if (response.data.stats) {
            this.pendingCount = response.data.stats.pending_count;
            this.inProgressCount = response.data.stats.in_progress_count;
            this.refusedCount = response.data.stats.refused_count;
            this.archivedCount = response.data.stats.archived_count;

            this.blockedCount = response.data.stats.blocked_count;
          }
        }
      } catch (error) {
        console.error('Erreur chargement documents:', error);
      } finally {
        this.isLoading = false;
      }
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      if (files.length > 0) {
        const entries = files.map(f => ({ file: f, forcedTypeId: '' }));
        this.selectedFiles = [...this.selectedFiles, ...entries];
      }
      // Reset input pour permettre re-sélection du même fichier
      event.target.value = '';
    },
    handleCameraCapture(event) {
      const files = Array.from(event.target.files);
      if (files.length > 0) {
        const entries = files.map(f => ({ file: f, forcedTypeId: '' }));
        this.selectedFiles = [...this.selectedFiles, ...entries];
      }
      event.target.value = '';
    },
    handleDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      if (files.length > 0) {
        const entries = files.map(f => ({ file: f, forcedTypeId: '' }));
        this.selectedFiles = [...this.selectedFiles, ...entries];
      }
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    async uploadDocuments() {
      if (this.selectedFiles.length === 0) return;

      this.isUploading = true;
      this.uploadProgress = {
        current: 0,
        total: this.selectedFiles.length,
        currentFile: '',
        results: []
      };

      const filesToProcess = [...this.selectedFiles];
      this.selectedFiles = [];

      for (let i = 0; i < filesToProcess.length; i++) {
        const entry = filesToProcess[i];
        this.uploadProgress.current = i;
        this.uploadProgress.currentFile = entry.file.name;

        try {
          // 1. Upload du fichier
          const formData = new FormData();
          formData.append('file', entry.file);
          // Si l'utilisateur a forcé un type pour CE fichier, on l'envoie
          if (entry.forcedTypeId) {
            formData.append('document_type_id', entry.forcedTypeId);
          }

          const uploadResponse = await axios.post('/api/scan-document/uploadDocument.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });

          if (!uploadResponse.data.success) {
            throw new Error(uploadResponse.data.error);
          }

          const documentId = uploadResponse.data.document_id;

          // 2. Analyse avec ChatGPT (auto-détection type + entreprise)
          const processResponse = await axios.post('/api/scan-document/processDocument.php', {
            document_id: documentId
          });

          if (processResponse.data.success) {
            const autoLinked = processResponse.data.auto_linked || 0;
            const typeClassified = processResponse.data.type_classified !== false;
            const typeSuggestion = processResponse.data.type_suggestion || null;

            let message = 'Analysé avec succès';
            if (autoLinked > 0) message += ` — ${autoLinked} document(s) rattaché(s)`;
            if (!typeClassified) {
              message += typeSuggestion
                ? ` — ⚠ type non reconnu (suggestion : « ${typeSuggestion} »), à assigner manuellement`
                : ' — ⚠ aucun type correspondant, à assigner manuellement';
            }

            this.uploadProgress.results.push({
              filename: entry.file.name,
              success: true,
              warn: !typeClassified,
              message,
              autoLinked: autoLinked
            });
          } else {
            this.uploadProgress.results.push({
              filename: entry.file.name,
              success: false,
              message: processResponse.data.error || 'Erreur d\'analyse'
            });
          }
        } catch (error) {
          this.uploadProgress.results.push({
            filename: entry.file.name,
            success: false,
            message: error.response?.data?.error || error.message
          });
        }

        // Recharger la liste après chaque fichier traité
        await this.loadDocuments();
        await this.loadCompanies(); // Rafraîchir aussi les entreprises au cas où une nouvelle a été créée
        // Si un document est ouvert dans le panneau détail, le rafraîchir aussi
        if (this.selectedDocument) {
          await this.viewDocument({ id: this.selectedDocument.id });
        }
      }

      this.uploadProgress.current = filesToProcess.length;
      this.uploadProgress.currentFile = '';

      const successCount = this.uploadProgress.results.filter(r => r.success).length;
      const errorCount = this.uploadProgress.results.filter(r => !r.success).length;
      const totalAutoLinked = this.uploadProgress.results.reduce((sum, r) => sum + (r.autoLinked || 0), 0);

      // Rafraîchissement final pour s'assurer que tout est à jour
      await this.loadDocuments();
      await this.loadCompanies();


      const linkMsg = totalAutoLinked > 0 ? ` (${totalAutoLinked} liaison${totalAutoLinked > 1 ? 's' : ''} auto)` : '';
      if (errorCount === 0) {
        this.showSuccess(`${successCount} document${successCount > 1 ? 's' : ''} analysé${successCount > 1 ? 's' : ''} avec succès !${linkMsg}`);
      } else if (successCount === 0) {
        this.showError(`Échec de l'analyse de ${errorCount} document${errorCount > 1 ? 's' : ''}`);
      } else {
        this.showInfo(`${successCount} réussi${successCount > 1 ? 's' : ''}, ${errorCount} échoué${errorCount > 1 ? 's' : ''}${linkMsg}`);
      }

      this.isUploading = false;
    },
    async processDocument(doc) {
      const result = await Swal.fire({
        title: 'Analyser ce document ?',
        text: 'Le document sera analysé par l\'IA',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#0d6efd',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Oui, analyser',
        cancelButtonText: 'Annuler'
      });
      
      if (!result.isConfirmed) return;

      try {
        const response = await axios.post('/api/scan-document/processDocument.php', {
          document_id: doc.id
        });

        if (response.data.success) {
          const autoLinked = response.data.auto_linked || 0;
          const linkMsg = autoLinked > 0 ? ` — ${autoLinked} document(s) rattaché(s)` : '';
          this.showSuccess('Document analysé avec succès !' + linkMsg);
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    async viewDocument(doc) {
      try {
        const response = await axios.get('/api/scan-document/getDocument.php?id=' + doc.id);
        if (response.data.success) {
          this.selectedDocument = response.data.document;
          this.isEditing = false;
          this.editForm = {};
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    closeDetailModal() {
      this.selectedDocument = null;
      this.isEditing = false;
      this.editForm = {};
    },
    startEditing() {
      this.isEditing = true;
      this.editForm = {
        company_id: this.selectedDocument.company_id || '',
        document_type_id: this.selectedDocument.document_type_id || '',
        document_number: this.selectedDocument.document_number || '',
        order_number: this.selectedDocument.order_number || '',
        document_date: this.selectedDocument.document_date || '',
        due_date: this.selectedDocument.due_date || '',
        payment_method: this.selectedDocument.payment_method || '',
        total_ht: this.selectedDocument.total_ht || '',
        total_tva: this.selectedDocument.total_tva || '',
        total_ttc: this.selectedDocument.total_ttc || '',
        magasin_id: this.selectedDocument.magasin_id || (this.selectedDocument.document_type_code === 'bon-de-livraison' ? 1 : ''),
        lines: JSON.parse(JSON.stringify(this.selectedDocument.lines || []))
      };
    },
    cancelEditing() {
      this.isEditing = false;
      this.editForm = {};
    },
    hasDocumentChanged() {
      // Vérifier si les champs du formulaire sont différents des valeurs originales
      const fields = ['company_id', 'document_type_id', 'document_number', 'order_number', 'document_date', 'due_date', 'payment_method', 'total_ht', 'total_tva', 'total_ttc', 'magasin_id'];
      
      for (const field of fields) {
        const originalValue = this.selectedDocument[field] || '';
        const editValue = this.editForm[field] || '';
        if (String(originalValue) !== String(editValue)) {
          return true;
        }
      }
      
      // Vérifier si les lignes ont changé
      const originalLines = JSON.stringify(this.selectedDocument.lines || []);
      const editLines = JSON.stringify(this.editForm.lines || []);
      if (originalLines !== editLines) {
        return true;
      }
      
      return false;
    },
    validateForm() {
      const errors = [];
      
      // Validation des montants (doivent être des nombres valides si renseignés)
      if (this.editForm.total_ht !== '' && this.editForm.total_ht !== null) {
        const ht = parseFloat(this.editForm.total_ht);
        if (isNaN(ht) || ht < 0) {
          errors.push('Le Total HT doit être un nombre positif');
        }
      }
      
      if (this.editForm.total_tva !== '' && this.editForm.total_tva !== null) {
        const tva = parseFloat(this.editForm.total_tva);
        if (isNaN(tva) || tva < 0) {
          errors.push('Le Total TVA doit être un nombre positif');
        }
      }
      
      if (this.editForm.total_ttc !== '' && this.editForm.total_ttc !== null) {
        const ttc = parseFloat(this.editForm.total_ttc);
        if (isNaN(ttc) || ttc < 0) {
          errors.push('Le Total TTC doit être un nombre positif');
        }
      }
      
      // Validation des dates (format valide si renseignées)
      if (this.editForm.document_date && this.editForm.document_date !== '') {
        const date = new Date(this.editForm.document_date);
        if (isNaN(date.getTime())) {
          errors.push('La date du document n\'est pas valide');
        }
      }
      
      if (this.editForm.due_date && this.editForm.due_date !== '') {
        const dueDate = new Date(this.editForm.due_date);
        if (isNaN(dueDate.getTime())) {
          errors.push('La date d\'échéance n\'est pas valide');
        }
      }
      
      // Validation des lignes pour les factures
      if (this.editForm.lines && this.editForm.lines.length > 0) {
        this.editForm.lines.forEach((line, index) => {
          if (line.quantity !== '' && line.quantity !== null) {
            const qty = parseFloat(line.quantity);
            if (isNaN(qty) || qty <= 0) {
              errors.push(`Ligne ${index + 1} : la quantité doit être un nombre positif`);
            }
          }
          
          if (line.unit_price !== '' && line.unit_price !== null) {
            const price = parseFloat(line.unit_price);
            if (isNaN(price) || price < 0) {
              errors.push(`Ligne ${index + 1} : le prix unitaire doit être un nombre positif`);
            }
          }
          
          if (line.total_ht !== '' && line.total_ht !== null) {
            const total = parseFloat(line.total_ht);
            if (isNaN(total) || total < 0) {
              errors.push(`Ligne ${index + 1} : le total HT doit être un nombre positif`);
            }
          }
          
          if (line.tva_rate !== '' && line.tva_rate !== null) {
            const tva = parseFloat(line.tva_rate);
            if (isNaN(tva) || tva < 0 || tva > 100) {
              errors.push(`Ligne ${index + 1} : le taux de TVA doit être entre 0 et 100`);
            }
          }
        });
      }
      
      return {
        valid: errors.length === 0,
        errors: errors
      };
    },
    async saveDocument() {
      // Vérifier si quelque chose a vraiment changé
      if (!this.hasDocumentChanged()) {
        this.isEditing = false;
        this.editForm = {};
        return;
      }
      
      // Valider le formulaire
      const validation = this.validateForm();
      if (!validation.valid) {
        const errorMessage = validation.errors.join('<br>');
        Swal.fire({
          icon: 'error',
          title: 'Erreurs de validation',
          html: errorMessage,
          confirmButtonColor: '#dc3545'
        });
        return;
      }
      
      this.isSaving = true;
      try {
        const response = await axios.post('/api/scan-document/updateDocument.php', {
          id: this.selectedDocument.id,
          ...this.editForm
        });

        if (response.data.success) {
          this.showSuccess('Document mis à jour avec succès !');
          this.isEditing = false;
          this.editForm = {};
          // Recharger le document pour avoir les lignes à jour
          await this.viewDocument({ id: this.selectedDocument.id });
          // Recharger la liste
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      } finally {
        this.isSaving = false;
      }
    },
    openFullPreview() {
      if (this.selectedDocument && this.selectedDocument.file_path) {
        window.open(this.getFileUrl(this.selectedDocument.file_path), '_blank');
      }
    },
    async openLinkModal(doc) {
      this.documentToLink = doc;
      this.selectedLinkDocuments = [];
      this.linkSearch = '';
      
      try {
        const params = new URLSearchParams();
        if (doc.company_id) params.append('company_id', doc.company_id);
        params.append('exclude_id', doc.id);
        
        const response = await axios.get('/api/scan-document/getLinkableDocuments.php?' + params.toString());
        if (response.data.success) {
          this.linkableDocuments = response.data.documents;
          this.showLinkModal = true;
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    toggleLinkSelection(docId) {
      const idx = this.selectedLinkDocuments.indexOf(docId);
      if (idx >= 0) {
        this.selectedLinkDocuments.splice(idx, 1);
      } else {
        this.selectedLinkDocuments.push(docId);
      }
    },
    debouncedLinkSearch() {
      if (this.linkSearchTimeout) clearTimeout(this.linkSearchTimeout);
      this.linkSearchTimeout = setTimeout(async () => {
        if (!this.documentToLink) return;
        try {
          const params = new URLSearchParams();
          if (this.documentToLink.company_id) params.append('company_id', this.documentToLink.company_id);
          params.append('exclude_id', this.documentToLink.id);
          if (this.linkSearch) params.append('search', this.linkSearch);
          
          const response = await axios.get('/api/scan-document/getLinkableDocuments.php?' + params.toString());
          if (response.data.success) {
            this.linkableDocuments = response.data.documents;
          }
        } catch (error) {
          console.error('Erreur recherche documents liables:', error);
        }
      }, 300);
    },
    async linkDocuments() {
      if (this.selectedLinkDocuments.length === 0 || !this.documentToLink) return;
      
      this.isLinking = true;
      try {
        const response = await axios.post('/api/scan-document/linkDocuments.php', {
          document_id: this.documentToLink.id,
          linked_document_ids: this.selectedLinkDocuments
        });

        if (response.data.success) {
          this.showSuccess(this.selectedLinkDocuments.length + ' document(s) lié(s) avec succès !');
          this.showLinkModal = false;
          this.selectedLinkDocuments = [];
          // Rafraîchir le document détail si ouvert
          if (this.selectedDocument && this.selectedDocument.id === this.documentToLink.id) {
            await this.viewDocument({ id: this.selectedDocument.id });
          }
          this.documentToLink = null;
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      } finally {
        this.isLinking = false;
      }
    },
    async unlinkDocument(docId, linkedId) {
      const result = await Swal.fire({
        title: 'Délier ce document ?',
        text: 'Le lien entre les deux documents sera supprimé',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Oui, délier',
        cancelButtonText: 'Annuler'
      });
      
      if (!result.isConfirmed) return;

      try {
        const response = await axios.post('/api/scan-document/unlinkDocument.php', {
          document_id: docId,
          linked_document_id: linkedId
        });

        if (response.data.success) {
          this.showSuccess('Documents déliés avec succès !');
          // Rafraîchir le document détail
          if (this.selectedDocument) {
            await this.viewDocument({ id: this.selectedDocument.id });
          }
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    formatWorkflowStatus(status) {
      return getStatusLabel(status);
    },
    isValidatedStatus(status) {
      // Statuts considérés comme "validés" (affichent un tampon de validation)
      const validatedStatuses = [
        'valide', 'en_cours_gpao', 'bl_receptionne', 'entree_gpao_validee', 'bl_valide',
        'en_attente_facture', 'facture_recue', 'facture_conforme',
        'facture_validee_compta', 'facture_payee'
      ];
      return validatedStatuses.includes(status);
    },
    getStatusColor(status) {
      return getStatusColor(status);
    },
    getTimelineDotClass(event) {
      // Priorité : couleur du nouveau statut si transition, sinon action
      if (event.new_status) {
        return 'dot-status-' + getStatusColor(event.new_status);
      }
      return 'dot-' + event.action;
    },
    getWorkflowBadgeClass(status) {
      return 'badge-wf-' + getStatusColor(status || 'en_attente');
    },
    async assignMagasin(magasinId) {
      if (!this.selectedDocument) return;
      try {
        const response = await axios.post('/api/scan-document/updateDocument.php', {
          id: this.selectedDocument.id,
          magasin_id: magasinId || null
        });
        if (response.data.success) {
          this.showSuccess('Magasin affecté !');
          await this.viewDocument({ id: this.selectedDocument.id });
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    async updateWorkflowStatus(newStatus, commentaire = null) {
      if (!this.selectedDocument || this.isUpdatingStatus) return;
      
      // Si action sensible, demander commentaire
      const sensitiveActions = ['refuse', 'facture_bloquee_gpao', 'en_attente'];
      if (sensitiveActions.includes(newStatus) && !commentaire) {
        const { value: comment, isConfirmed } = await Swal.fire({
          title: 'Commentaire',
          input: 'textarea',
          inputLabel: 'Raison du changement de statut (facultatif)',
          inputPlaceholder: 'Saisissez un commentaire...',
          showCancelButton: true,
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Annuler',
          confirmButtonColor: '#2b358d',
        });
        if (!isConfirmed) return;
        commentaire = comment || null;
      }

      this.isUpdatingStatus = true;
      try {
        const response = await axios.post('/api/scan-document/updateWorkflowStatus.php', {
          document_id: this.selectedDocument.id,
          workflow_status: newStatus,
          commentaire: commentaire
        });

        if (response.data.success) {
          this.showSuccess('Statut mis à jour !');
          // Rafraîchir le document détail
          await this.viewDocument({ id: this.selectedDocument.id });
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      } finally {
        this.isUpdatingStatus = false;
      }
    },
    async toggleChildren(docId) {
      const idx = this.expandedDocs.indexOf(docId);
      if (idx >= 0) {
        this.expandedDocs.splice(idx, 1);
      } else {
        this.expandedDocs.push(docId);
        // Charger les enfants si pas encore chargés
        const doc = this.documents.find(d => d.id === docId);
        if (doc && !doc._children) {
          try {
            const response = await axios.get('/api/scan-document/getDocument.php?id=' + docId);
            if (response.data.success && response.data.document.child_documents) {
              doc._children = response.data.document.child_documents;
            }
          } catch (error) {
            console.error('Erreur chargement enfants:', error);
          }
        }
      }
    },
    getRowHighlightClass(doc) {
      const classes = [];
      
      // Surbrillance document lié
      if (this.highlightedDocId === doc.id) {
        classes.push('highlight-linked');
      }
      
      // Fond selon le statut workflow
      const status = doc.workflow_status || 'en_attente';
      if (status === 'en_attente') {
        classes.push('row-wf-attente');
      } else if (status === 'valide') {
        classes.push('row-wf-valide');
      } else if (status === 'refuse') {
        classes.push('row-wf-refuse');
      }
      
      return classes;
    },
    async deleteDocument(doc) {
      const result = await Swal.fire({
        title: 'Supprimer ce document ?',
        text: 'Cette action est irréversible',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Oui, supprimer',
        cancelButtonText: 'Annuler'
      });
      
      if (!result.isConfirmed) return;

      try {
        const response = await axios.post('/api/scan-document/deleteDocument.php', {
          id: doc.id
        });

        if (response.data.success) {
          this.showSuccess('Document supprimé avec succès !');
          this.loadDocuments();
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    },
    async exportCSV() {
      try {
        const params = new URLSearchParams();
        if (this.filters.company_id)        params.append('company_id', this.filters.company_id);
        if (this.filters.document_type_id)  params.append('document_type_id', this.filters.document_type_id);
        if (this.filters.workflow_status)   params.append('workflow_status', this.filters.workflow_status);
        if (this.searchTerm)                params.append('search', this.searchTerm);
        if (this.filters.period === 'personnalisee') {
          if (this.filters.customDateFrom) params.append('date_from', this.filters.customDateFrom);
          if (this.filters.customDateTo)   params.append('date_to', this.filters.customDateTo);
        } else {
          const dates = this.computePeriodDates();
          if (dates) {
            params.append('date_from', dates.from);
            params.append('date_to', dates.to);
          }
        }

        const response = await axios.get('/api/scan-document/exportDocuments.php?' + params.toString(), {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export_documents_' + new Date().toISOString().slice(0, 10) + '.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.showSuccess('Export CSV téléchargé !');
      } catch (error) {
        console.error('Erreur export CSV:', error);
        this.showError('Erreur lors de l\'export CSV');
      }
    },
    getFileUrl(path) {
      return 'https://www.simef.fr/espace-client/' + path;
    },
    openFile(path) {
      window.open(this.getFileUrl(path), '_blank');
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('fr-FR');
    },
    formatDateTime(datetime) {
      if (!datetime) return '-';
      const date = new Date(datetime);
      return date.toLocaleDateString('fr-FR') + ' à ' + date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    },
    isDocumentModified(document) {
      if (!document) return false;
      // Si updated_at n'existe pas, est null ou est identique à created_at, le document n'a pas été modifié manuellement
      if (!document.updated_at) return false;
      // Retourne true seulement si updated_at et created_at sont différents
      return document.updated_at !== document.created_at;
    },
    formatMoney(amount) {
      if (amount === null || amount === undefined) return '-';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    getStatusClass(status) {
      const classes = {
        'pending': 'bg-warning',
        'processing': 'bg-info',
        'completed': 'bg-success',
        'error': 'bg-danger'
      };
      return classes[status] || 'bg-secondary';
    },
    getStatusLabel(status) {
      const labels = {
        'pending': 'En attente',
        'processing': 'En cours de traitement',
        'completed': 'Traité',
        'error': 'Erreur'
      };
      return labels[status] || status;
    },
    async addDocumentType() {
      if (!this.newDocType.name) return;

      this.isSavingDocType = true;
      try {
        const response = await axios.post('/api/scan-document/createDocumentType.php', {
          name: this.newDocType.name,
          code: this.newDocType.code || undefined,
          description: this.newDocType.description || undefined
        });

        if (response.data.success) {
          await this.loadDocumentTypes();
          this.newDocType = { name: '', code: '', description: '' };
          this.showSuccess('Type de document ajouté avec succès !');
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        console.error('Erreur ajout type:', error);
        this.showError(error.response?.data?.error || error.message);
      } finally {
        this.isSavingDocType = false;
      }
    },
    async deleteDocumentType(dtype) {
      const result = await Swal.fire({
        title: 'Supprimer ce type ?',
        html: `Le type <strong>${dtype.name}</strong> sera définitivement supprimé.<br>Cette action est irréversible.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler'
      });

      if (!result.isConfirmed) return;

      try {
        const response = await axios.post('/api/scan-document/deleteDocumentType.php', { id: dtype.id });
        if (response.data.success) {
          await this.loadDocumentTypes();
          this.showSuccess('Type supprimé avec succès !');
        } else {
          this.showError(response.data.error);
        }
      } catch (error) {
        this.showError(error.response?.data?.error || error.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #2b358d;

.hello {
  padding-bottom: 50px;
}

h1 {
  text-align: center;
}

h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: $primary;
}

/* Section Upload */
.upload-section {
  margin-bottom: 30px;
}

.upload-card, .info-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(43,53,141,0.07);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.upload-card-header, .info-card-header {
  background: $primary;
  color: #fff;
  padding: 15px 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  svg {
    width: 18px;
    height: 18px;
  }
}

.upload-card-body, .info-card-body {
  padding: 20px;
  flex: 1;
}

.info-card-body ol {
  padding-left: 20px;
  margin-bottom: 20px;
  li {
    margin-bottom: 10px;
    font-weight: 500;
  }
}

.info-tip {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.95rem;
  svg {
    color: $primary;
    flex-shrink: 0;
    margin-top: 2px;
  }
}

/* Formulaires */
.form-group {
  margin-bottom: 20px;
  label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
  }
  input, select, textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.95rem;
    background: #fff;
    &:focus {
      outline: none;
      border-color: $primary;
    }
  }
}

.input-with-btn {
  display: flex;
  gap: 8px;
  select, input {
    flex: 1;
  }

  select {
    margin-bottom: 0 !important;
  }
}

.btn-add {
  background: $primary;
  color: #fff;
  border: none;
  margin: 0 !important;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  font-weight: 500;
  transition: background 0.2s;
  &:hover {
    background: darken($primary, 8%);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  svg {
    width: 16px;
    height: 16px;
    margin: 0;
  }
}

.btn-submit {
  width: 100%;
  background: $primary;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
  &:hover:not(:disabled) {
    background: darken($primary, 8%);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  svg {
    width: 16px;
    height: 16px;
  }
}

/* Dropzone */
.dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: $primary;
    background: #f0f4fa;
  }
  &.dropzone-active {
    border-color: $primary;
    background: #f0f4fa;
  }
  svg {
    color: #999;
    margin: 0 !important;
  }
  p {
    margin: 10px 0 5px;
    font-weight: 500;
  }
  small {
    color: #888;
  }
  .btn-remove-file {
    margin-top: 0 !important;
  }
}

.dropzone-placeholder,
.dropzone-file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dropzone-file svg {
  color: #28a745;
}

/* Liste fichiers multi-upload */
.dropzone-files-list {
  width: 100%;
  text-align: left;
}

.dropzone-files-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #2b358d;
  svg {
    color: #2b358d;
  }
}

.dropzone-files-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 8px;
}

.dropzone-file-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #f8f9fa;
  font-size: 13px;

  .file-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .file-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
  }
  .file-size {
    color: #888;
    white-space: nowrap;
  }

  .file-item-type {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .file-type-select {
    width: 100%;
    padding: 4px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    background: #fff;
    color: #495057;
    cursor: pointer;
    &:focus {
      outline: none;
      border-color: $primary;
    }
  }
}

.btn-remove-file {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #dc3545;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  min-height: 26px;
  transition: all 0.2s ease;
  &:hover {
    background: #f8d7da;
    transform: scale(1.1);
  }
}

.dropzone-add-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.dropzone-add-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  color: #2b358d;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  &:hover {
    text-decoration: underline;
  }
}

.btn-camera {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 20px;
  background: #2b358d;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: #1e2666;
    transform: translateY(-1px);
  }
  svg {
    flex-shrink: 0;
  }
}

/* Barre de progression upload */
.upload-progress-section {
  margin: 15px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.upload-progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
}

.upload-progress-percent {
  color: #2b358d;
}

.upload-progress-bar {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.upload-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #2b358d, #4a56c8, #2b358d);
  background-size: 200% 100%;
  border-radius: 4px;
  transition: width 0.5s ease;
  animation: progress-shimmer 2s ease-in-out infinite;
}

@keyframes progress-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.upload-progress-current {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.loader-animation {
  flex-shrink: 0;
}

.loader-box {
  display: flex;
  gap: 8px;
  align-items: center;
}

.loader-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2b358d, #4a56c8);
  animation: loader-bounce 1.4s ease-in-out infinite;
  
  &:nth-child(1) {
    animation-delay: 0s;
  }
  
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
}

@keyframes loader-bounce {
  0%, 80%, 100% {
    transform: scale(0.8) translateY(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2) translateY(-10px);
    opacity: 1;
  }
}

.analyzing-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.analyzing-label {
  font-size: 13px;
  font-weight: 600;
  color: #2b358d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.analyzing-filename {
  font-size: 14px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.upload-progress-results {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  max-height: 150px;
  overflow-y: auto;
  li {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 0;
    font-size: 12px;
  }
}

.result-success {
  color: #28a745;
}

.result-warn {
  color: #e67e22;
}

.result-error {
  color: #dc3545;
}

.spinner-inline {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Filtres */
.filters {
  margin-bottom: 20px;
  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    .search-input {
      min-width: 250px;
      padding: 10px 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 0.95rem;
      background: #fff;
      &:focus {
        outline: none;
        border-color: $primary;
      }
    }
    select {
      min-width: 180px;
    }
    .select-period {
      min-width: 190px;
    }
    .input-date {
      padding: 9px 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 0.95rem;
      background: #fff;
      &:focus {
        outline: none;
        border-color: $primary;
      }
    }
  }
}

.btn-reset,
.btn-export,
.btn-manage {
  background: $primary;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
  margin: 0px !important;
  &:hover {
    background: darken($primary, 8%);
  }
  svg {
    width: 16px;
    height: 16px;
  }
}

.btn-reset {
  background: #6c757d;
  &:hover {
    background: darken(#6c757d, 8%);
  }
}

.btn-manage {
  background: #495057;
  &:hover {
    background: darken(#495057, 8%);
  }
}

.ops-actions {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Tableau */
.table-responsive-modern {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

/* Édition des lignes */
.lines-edit-section {
  margin-top: 15px;
}

.line-edit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: all 0.2s;
  
  &:hover {
    background: #e9ecef;
  }
}

.line-number {
  font-weight: 600;
  color: #2b358d;
  min-width: 30px;
}

.line-input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  flex: 1;
  min-width: 80px;
  
  &:focus {
    outline: none;
    border-color: #2b358d;
    box-shadow: 0 0 0 2px rgba(43, 53, 141, 0.1);
  }
  
  &.line-input-wide {
    flex: 2;
  }
  
  &.line-input-sm {
    max-width: 100px;
  }
  
  &.line-input-xs {
    max-width: 60px;
  }
}

table.documentsListeModern {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 16px rgba(43,53,141,0.07);
  overflow: hidden;
  thead {
    background: $primary;
    color: #fff;
    th {
      padding: 14px 10px;
      font-size: 0.95rem;
      font-weight: 700;
      color: #fff;
      background: $primary;
      border: none;
      text-align: left;
      vertical-align: middle;
    }
  }
  tbody {
    tr {
      transition: background 0.15s;
      &:hover {
        background: #f0f4fa;
      }
    }
    td {
      padding: 12px 10px;
      font-size: 0.95rem;
      font-weight: 500;
      vertical-align: middle;
      text-align: left;
    }
    td.td-file {
      > * {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
  a {
    color: $primary;
    text-decoration: none;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    &:hover {
      text-decoration: underline;
    }
  }
}

/* Badges */
.badge-type {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.badge-facture {
  padding: 4px 10px;
  border-radius: 4px;
  background: #0d6efd;
  color: #fff;
}

.badge-fourniture-client {
  padding: 4px 10px;
  border-radius: 4px;
  background: #20c997;
  color: #fff;
}

.badge-other {
  padding: 4px 10px;
  border-radius: 4px;
  background: #17a2b8;
  color: #fff;
}

.badge-livraison {
  padding: 4px 10px;
  border-radius: 4px;
  background: #17a2b8;
  color: #fff;
}

.badge-devis {
  padding: 4px 10px;
  border-radius: 4px;
  background: #6f42c1;
  color: #fff;
}

.badge-avoir {
  padding: 4px 10px;
  border-radius: 4px;
  background: #e83e8c;
  color: #fff;
}

.badge-contrat {
  padding: 4px 10px;
  border-radius: 4px;
  background: #20c997;
  color: #fff;
}

.badge-rh {
  padding: 4px 10px;
  border-radius: 4px;
  background: #fd7e14;
  color: #fff;
}

.badge-commande {
  padding: 4px 10px;
  border-radius: 4px;
  background: #007bff;
  color: #fff;
}

.badge-financier {
  padding: 4px 10px;
  border-radius: 4px;
  background: #28a745;
  color: #fff;
}

.badge-admin {
  padding: 4px 10px;
  border-radius: 4px;
  background: #6c757d;
  color: #fff;
}

.badge-pending {
  background: #ffc107;
  color: #333;
  font-style: italic;
}

.text-muted {
  color: #999;
  font-style: italic;
}

.extracted-list {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    padding: 4px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
    span {
      font-size: 0.9rem;
    }
  }
}

.badge-status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  
  &.clickable {
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }
  }
}

.status-pending {
  background: #dc3545;
  color: #fff;
}

.status-processing {
  background: #17a2b8;
  color: #fff;
}

.status-completed {
  background: #28a745;
  color: #fff;
}

.status-error {
  background: #6c757d;
  color: #fff;
}

/* Liens texte soulignés */
.link-text {
  text-decoration: underline;
  color: $primary;
  cursor: pointer;
  font-size: 0.9rem;
  
  &:hover {
    color: darken($primary, 15%);
  }
  
  &.link-action {
    color: #666;
    
    &:hover {
      color: $primary;
    }
  }
}

/* Surbrillance lignes tableau */
.highlight-pending {
  background-color: rgba(220, 53, 69, 0.15) !important;
  animation: pulse-red 1s ease-in-out infinite alternate;
}

.highlight-completed {
  background-color: rgba(40, 167, 69, 0.15) !important;
  animation: pulse-green 1s ease-in-out infinite alternate;
}

.highlight-linked {
  background-color: rgba(43, 53, 141, 0.2) !important;
  animation: pulse-blue 1s ease-in-out 3;
}

/* Fond lignes selon statut workflow */
.row-wf-attente {
  background-color: #fff3cd !important;
  &:hover {
    background-color: #fff9e6 !important;
  }
}

.row-wf-valide {
  background-color: #d4edda !important;
  &:hover {
    background-color: #eaf7ed !important;
  }
}

.row-wf-refuse {
  background-color: #f8d7da !important;
  &:hover {
    background-color: #fce8ea !important;
  }
}

@keyframes pulse-red {
  from { background-color: rgba(220, 53, 69, 0.1); }
  to { background-color: rgba(220, 53, 69, 0.25); }
}

@keyframes pulse-green {
  from { background-color: rgba(40, 167, 69, 0.1); }
  to { background-color: rgba(40, 167, 69, 0.25); }
}

@keyframes pulse-blue {
  from { background-color: rgba(43, 53, 141, 0.1); }
  to { background-color: rgba(43, 53, 141, 0.3); }
}

/* Cellules tronquées */
.td-truncate {
  max-width: 180px;
}
.cell-truncate {
  display: block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-truncate[title]:hover {
  cursor: help;
}

/* Actions */
.actions-cell {
  display: flex;
  gap: 5px;
  justify-content: flex-start;
}

.btn-action {
  background: transparent;
  border: 1px solid #ccc;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  margin: 0px !important;
  svg {
    width: 16px;
    height: 16px;
    margin: 0;
  }
}

.btn-view {
  color: #ffffff;
  border-color: $primary;
  &:hover {
    background: $primary;
    color: #fff;
  }
}

.btn-process {
  color: #28a745;
  border-color: #28a745;
  &:hover {
    background: #28a745;
    color: #fff;
  }
}

.btn-delete {
  color: #dc3545;
  border-color: #dc3545;
  &:hover {
    background: #dc3545;
    color: #fff;
  }
}

.btn-open-pdf {
  color: #fff;
  border-color: #2b358d;
  &:hover {
    background: #495057;
    color: #fff;
    border-color: #495057;
  }
  svg {
    fill: currentColor;
  }
}

.loading-inline {
  padding: 30px;
  font-style: italic;
  color: #888;
}

/* Popups */
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
}

.popup-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 30px rgba(0,0,0,0.3);
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
  max-width: 500px;
}

.popup-content.popup-sm {
  max-width: 400px;
}

.popup-content.popup-lg {
  max-width: 700px;
}

.popup-content.popup-xl {
  max-width: 1000px;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  h2 {
    margin: 0 !important;
    font-size: 1.3rem;
    color: $primary;
  }

  .close-button {
    position: relative;
    top: 0;
    left: 0;
    margin: 0 !important;
  }
}

.close-button {
  font-size: 28px;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  line-height: 1;
  text-decoration: none;
  transition: color 0.2s;
  flex-shrink: 0;
  &:hover {
    color: #333;
  }
}

.popup-body {
  padding: 20px;
}

.popup-section {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
}

.popup-actions {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  
  &.no-modified-info {
    justify-content: flex-end;
  }
}

.left-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.document-modified-info {
  font-size: 0.95rem;
  color: #6c757d;
  font-style: italic;
  font-weight: 500;
  text-align: left;
}

.document-linked-info {
  font-size: 0.9rem;
  color: #2b358d;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  
  svg {
    flex-shrink: 0;
  }
  
  strong {
    color: #2b358d;
  }
}

.btn-secondary {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  &:hover {
    background: darken(#6c757d, 8%);
  }
}

.btn-danger {
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  &:hover {
    background: darken(#dc3545, 8%);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.warning-text {
  color: #856404;
  background: #fff3cd;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  svg {
    color: #856404;
  }
}

.empty-state {
  text-align: center;
  padding: 30px;
  color: #888;
  font-style: italic;
}

.description-cell {
  color: #888;
  font-size: 0.9rem;
}

/* Table détails */
.table-details {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  tr {
    border-bottom: 1px solid #eee;
  }
  th, td {
    padding: 10px;
    text-align: left;
  }
  th {
    color: #666;
    font-weight: 600;
    width: 40%;
  }
  .row-highlight {
    background: #f0f4fa;
    td, th {
      color: $primary;
    }
  }
}

/* Checkbox group */
.checkbox-group {
  margin-bottom: 15px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: $primary;
    cursor: pointer;
  }
}

/* Stats section */
.stats-section {
  display: flex;
  gap: 20px;
  margin: 20px 0;
}

.stat-item {
  flex: 1;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  
  .stat-number {
    display: block;
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.2;
  }
  
  .stat-label {
    font-size: 0.85rem;
    color: #666;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  &.stat-pending {
    background: #fff3cd;
    .stat-number {
      color: #856404;
    }
    &.active {
      border-color: #dc3545;
      background: #f8d7da;
    }
  }
  
  &.stat-completed {
    background: #d4edda;
    .stat-number {
      color: #155724;
    }
    &.active {
      border-color: #28a745;
      background: #c3e6cb;
    }
  }
  
  &.stat-refused {
    background: #f8d7da;
    .stat-number {
      color: #721c24;
    }
    &.active {
      border-color: #dc3545;
      background: #f5c6cb;
    }
  }

  &.stat-archived {
    background: #e2e3e5;
    .stat-number {
      color: #383d41;
    }
    &.active {
      border-color: #6c757d;
      background: #d6d8db;
    }
  }
}

/* Document preview */
.row-preview-stretch {
  display: flex;
  align-items: stretch;
}
.col-preview-stretch {
  position: sticky;
  top: 15px;
  align-self: flex-start;
}

.document-preview {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.preview-container {
  width: 100%;
  height: 520px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
  position: relative;
}

.pdf-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.img-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: zoom-in;
}

.no-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #888;
  font-style: italic;
}

.btn-open-file {
  display: block;
  text-align: center;
  padding: 8px 15px;
  background: $primary;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: background 0.2s;
  
  &:hover {
    background: darken($primary, 10%);
    color: #fff;
  }
}

/* Edit form */
.edit-form {
  .form-group {
    margin-bottom: 12px;
    
    label {
      display: block;
      font-weight: 500;
      margin-bottom: 5px;
      color: #555;
      font-size: 0.9rem;
    }
    
    input {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 0.95rem;
      
      &:focus {
        outline: none;
        border-color: $primary;
        box-shadow: 0 0 0 2px rgba($primary, 0.1);
      }
    }
  }
}

/* Boutons action popup */
.btn-edit, .btn-save {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit {
  background: $primary;
  color: #ffffff;
}

.btn-validate {
  background: #28a745;
  color: #fff;
  
  &:hover:not(:disabled) {
    background: darken(#28a745, 8%);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.btn-save {
  background: $primary;
  color: #fff;
  
  &:hover {
    background: darken($primary, 10%);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

/* Liaison documents */
/* ========================================
   MODAL LIAISON DOCUMENTS
   ======================================== */
.popup-link {
  max-width: 680px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 85vh;

  .popup-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
  }
}

.link-modal-context {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 0.88rem;
}

.link-modal-context-label {
  color: #6c757d;
  font-weight: 500;
  white-space: nowrap;
}

.link-modal-context-name {
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link-modal-search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid #e9ecef;

  svg {
    flex-shrink: 0;
    color: #aaa;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 0.92rem;
    background: transparent;
    color: #333;

    &::placeholder {
      color: #bbb;
    }
  }
}

.linkable-documents {
  flex: 1;
  overflow-y: auto;
  min-height: 120px;
  max-height: 380px;
}

.linkable-doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s;

  &:last-child { border-bottom: none; }

  &:hover {
    background: #f8f9fa;
  }

  &.selected {
    background: rgba($primary, 0.06);

    .ldi-checkbox {
      background: $primary;
      border-color: $primary;
      color: #fff;
    }
  }
}

.ldi-check {
  flex-shrink: 0;
}

.ldi-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 2px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  transition: all 0.15s;
}

.ldi-body {
  flex: 1;
  min-width: 0;
}

.ldi-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 3px;
}

.ldi-name {
  font-size: 0.88rem;
  font-weight: 500;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ldi-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.78rem;
  color: #888;
  flex-wrap: wrap;
}

.ldi-number {
  font-weight: 600;
  color: #555;
}

.ldi-company {
  color: #666;
}

.ldi-date {}

.ldi-amount {
  font-weight: 600;
  color: #333;
}

.link-modal-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 20px;
  color: #aaa;
  font-size: 0.9rem;

  svg { opacity: 0.4; }
}

.link-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  gap: 12px;
}

.link-modal-count {
  font-size: 0.85rem;
  font-weight: 600;
  color: $primary;

  &.empty {
    color: #aaa;
    font-weight: 400;
  }
}

.link-modal-actions {
  display: flex;
  gap: 8px;
}

/* Doc lié dans tableau */
.linked-doc a {
  color: $primary;
  text-decoration: none;
  font-size: 0.9rem;
  
  &:hover {
    text-decoration: underline;
  }
}

.btn-link {
  background: #f0f4fa !important;
  color: $primary !important;
}

/* Popup xl */
.popup-xl {
  max-width: 1000px;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

/* Responsive */
@media screen and (max-width: 992px) {
  .upload-section .col-lg-6:first-child {
    margin-bottom: 20px;
  }
  .filters .search {
    flex-direction: column;
    select, .btn-export, .btn-manage {
      width: 100%;
    }
  }
  .popup-content {
    max-width: 95%;
  }
  
  .stats-section {
    flex-direction: column;
    gap: 10px;
  }
  
  .popup-xl .row {
    flex-direction: column;
  }
  
  .popup-xl .col-md-3 {
    margin-bottom: 20px;
  }
}

/* Pagination */
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 8px 8px;
}

.pagination-info {
  font-size: 0.85rem;
  color: #666;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #fff;
  color: #ffffff;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.15s ease;
}

.pagination-btn svg {
  margin: 0 !important;
}

.pagination-btn:hover:not(:disabled):not(.active) {
  background: #f5f7fa;
  border-color: #b0b7c3;
}

.pagination-btn.active {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
  font-weight: 600;
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: #999;
  font-size: 0.85rem;
}

/* ========================================
   WORKFLOW STATUS BADGES
   ======================================== */
.badge-workflow {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}

.badge-workflow.badge-lg {
  padding: 6px 14px;
  font-size: 0.9rem;
}

/* Couleurs par type de statut (utilisées via getStatusColor()) */
.badge-wf-pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
}

.badge-wf-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #28a745;
}

.badge-wf-danger {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #dc3545;
}

.badge-wf-materiel {
  background: #cce5ff;
  color: #004085;
  border: 1px solid #007bff;
}

.badge-wf-fourniture {
  background: #e0f2e9;
  color: #1a5c35;
  border: 1px solid #27ae60;
}

.badge-wf-info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #17a2b8;
}

.badge-wf-progress {
  background: #d6e9f8;
  color: #1a5276;
  border: 1px solid #2980b9;
}

.badge-wf-waiting {
  background: #fde8d0;
  color: #7d5a29;
  border: 1px solid #e67e22;
}

.badge-wf-paid {
  background: #d5f5e3;
  color: #1e6e3e;
  border: 1px solid #27ae60;
}

.badge-wf-archive {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #6c757d;
}

.badge-wf-warning {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #e2a907;
}

/* ========================================
   WORKFLOW SECTION (Detail Modal)
   ======================================== */
/* ========================================
   WORKFLOW SECTION
   ======================================== */
.workflow-section {
  position: relative;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e0e4ea;
  overflow: hidden;
}

.wf-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 20px;
  gap: 16px;
}

.wf-status-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wf-section-label {
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9aa3b0;
  margin-bottom: 2px;
}

.wf-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wf-subtitle {
  margin: 4px 0 0;
  font-size: 0.8rem;
  color: #6c757d;

  &.wf-subtitle-danger  { color: #842029; }
  &.wf-subtitle-archive { color: #383d41; }
  &.wf-subtitle-warning { color: #664d03; }
}

.wf-magasin {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.badge-magasin {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  background: #198754;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
}

.select-magasin-inline {
  padding: 4px 10px;
  border-radius: 20px;
  border: 1.5px solid #198754;
  font-size: 0.82rem;
  font-weight: 600;
  color: #198754;
  background: #fff;
  cursor: pointer;
  outline: none;
  max-width: 200px;
  &:focus {
    box-shadow: 0 0 0 2px rgba(25, 135, 84, 0.22);
  }
}

.wf-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 20px;
  background: #f7f8fa;
  border-top: 1px solid #e8eaed;
}

.wf-no-actions {
  font-size: 0.8rem;
  color: #adb5bd;
  font-style: italic;
}

.btn-wf {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.18s;
  white-space: nowrap;
  margin: 0 !important;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  svg {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
  }
}

/* Boutons workflow — couleurs selon getStatusColor() */
.btn-wf-success  { background: #28a745; color: #fff; &:hover:not(:disabled) { background: #218838; } }
.btn-wf-danger   { background: #dc3545; color: #fff; &:hover:not(:disabled) { background: #c82333; } }
.btn-wf-pending  { background: #e0a800; color: #fff; &:hover:not(:disabled) { background: #c69500; } }
.btn-wf-info     { background: #17a2b8; color: #fff; &:hover:not(:disabled) { background: #138496; } }
.btn-wf-progress { background: #2980b9; color: #fff; &:hover:not(:disabled) { background: #1a6fa0; } }
.btn-wf-waiting  { background: #e67e22; color: #fff; &:hover:not(:disabled) { background: #ca6f1e; } }
.btn-wf-paid     { background: #27ae60; color: #fff; &:hover:not(:disabled) { background: #1e8449; } }
.btn-wf-archive  { background: #6c757d; color: #fff; &:hover:not(:disabled) { background: #5a6268; } }
.btn-wf-warning  { background: #e2a907; color: #fff; &:hover:not(:disabled) { background: #c79406; } }
.btn-wf-edit     { background: $primary; color: #fff; &:hover:not(:disabled) { background: darken($primary, 8%); } }

/* ========================================
   VALIDATION STAMP (conservé pour rétrocompat éventuelle)
   ======================================== */
.validation-stamp {
  display: none;

  &.validation-stamp-pending {
    background: linear-gradient(135deg, #fff3cd, #ffe8a1);
    border-color: #f0a500;

    .stamp-icon {
      background: #f0a500;
    }

    .stamp-label,
    .stamp-date,
    .stamp-user,
    .stamp-sep {
      color: #7d4e00;
    }
  }

  &.validation-stamp-info {
    background: linear-gradient(135deg, #d1ecf1, #bee5eb);
    border-color: #17a2b8;

    .stamp-icon { background: #17a2b8; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #0c5460; }
  }

  &.validation-stamp-progress {
    background: linear-gradient(135deg, #d6e9f8, #b8d4ed);
    border-color: #2980b9;

    .stamp-icon { background: #2980b9; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #1a5276; }
  }

  &.validation-stamp-success {
    background: linear-gradient(135deg, #d4edda, #c3e6cb);
    border-color: #28a745;

    .stamp-icon { background: #28a745; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #155724; }
  }

  &.validation-stamp-waiting {
    background: linear-gradient(135deg, #fde8d0, #fad7b4);
    border-color: #e67e22;

    .stamp-icon { background: #e67e22; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #7d5a29; }
  }

  &.validation-stamp-paid {
    background: linear-gradient(135deg, #d5f5e3, #abebc6);
    border-color: #27ae60;

    .stamp-icon { background: #27ae60; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #1e6e3e; }
  }

  &.validation-stamp-danger {
    background: linear-gradient(135deg, #f8d7da, #f5c6cb);
    border-color: #dc3545;

    .stamp-icon { background: #dc3545; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #721c24; }
  }

  &.validation-stamp-warning {
    background: linear-gradient(135deg, #fff3cd, #ffe8a1);
    border-color: #e2a907;

    .stamp-icon { background: #e2a907; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #856404; }
  }

  &.validation-stamp-archive {
    background: linear-gradient(135deg, #e2e3e5, #d6d8db);
    border-color: #6c757d;

    .stamp-icon { background: #6c757d; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #383d41; }
  }

  &.validation-stamp-materiel {
    background: linear-gradient(135deg, #cce5ff, #b8daff);
    border-color: #007bff;

    .stamp-icon { background: #007bff; }
    .stamp-label, .stamp-date, .stamp-user, .stamp-sep { color: #004085; }
  }
}

.stamp-icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  background: #28a745;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 24px;
    height: 24px;
  }
}

.stamp-info {
  flex: 1;
  margin: 0;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stamp-sep {
  color: #155724;
  font-weight: 400;
  opacity: 0.5;
}

.stamp-label {
  font-size: 0.82rem;
  color: #155724;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.stamp-date {
  font-size: 1.05rem;
  font-weight: 700;
  color: #155724;
}

.stamp-user {
  font-size: 0.9rem;
  color: #155724;
  font-weight: 500;
}

/* ========================================
   LINKED DOCUMENTS SECTION (Detail Modal)
   ======================================== */
.linked-docs-section {
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.linked-docs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  
  h3 {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    
    svg {
      color: $primary;
    }
  }
}

.btn-link-add {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: $primary;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: darken($primary, 8%);
  }
  
  svg {
    width: 14px;
    height: 14px;
  }
}

.linked-docs-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.linked-doc-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s;
  
  &:hover {
    background: #e9ecef;
  }
}

.linked-doc-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.badge-auto-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  font-size: 0.7rem;
  font-weight: 600;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 10px;
  white-space: nowrap;
  
  svg {
    flex-shrink: 0;
  }
}

.badge-sm {
  padding: 2px 7px !important;
  font-size: 0.75rem !important;
}

.linked-doc-name {
  font-weight: 500;
  color: $primary;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  
  &:hover {
    text-decoration: underline;
  }
}

.linked-doc-number {
  color: #666;
  font-size: 0.85rem;
}

.linked-doc-date {
  color: #888;
  font-size: 0.82rem;
}

.linked-doc-amount {
  font-weight: 600;
  color: #155724;
  font-size: 0.9rem;
}

.linked-doc-actions {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.linked-docs-empty {
  text-align: center;
  padding: 20px;
  color: #888;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 6px;
}

/* ========================================
   HISTORY / TIMELINE (Detail Modal)
   ======================================== */
.history-section {
  border-top: 1px solid #eee;
  padding-top: 20px;
  
  h3 {
    display: flex;
    align-items: center;
    gap: 8px;
    
    svg {
      color: $primary;
    }
  }
}

.timeline {
  position: relative;
  padding-left: 24px;
  
  &::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #e0e0e0;
  }
}

.timeline-item {
  position: relative;
  padding-bottom: 16px;
  
  &:last-child {
    padding-bottom: 0;
  }
}

.timeline-dot {
  position: absolute;
  left: -20px;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #6c757d;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #e0e0e0;
  
  &.dot-status_change {
    background: #ffc107;
  }
  
  &.dot-link_documents {
    background: $primary;
  }
  
  &.dot-unlink_document {
    background: #dc3545;
  }
  
  &.dot-validation {
    background: #28a745;
  }

  /* Couleurs selon getStatusColor() du nouveau statut */
  &.dot-status-pending   { background: #ffc107; }
  &.dot-status-info      { background: #17a2b8; }
  &.dot-status-progress  { background: #2980b9; }
  &.dot-status-success   { background: #28a745; }
  &.dot-status-waiting   { background: #e67e22; }
  &.dot-status-paid      { background: #27ae60; }
  &.dot-status-materiel  { background: #007bff; }
  &.dot-status-danger    { background: #dc3545; }
  &.dot-status-archive   { background: #6c757d; }
  &.dot-status-warning   { background: #e2a907; }
}

.timeline-content {
  padding-left: 8px;
}

.timeline-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.timeline-transition {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 0.78rem;
}

.transition-arrow {
  color: #888;
  font-weight: 700;
  font-size: 0.9rem;
}

.badge-workflow.badge-xs {
  padding: 1px 5px;
  font-size: 0.68rem;
}

.timeline-meta {
  font-size: 0.8rem;
  color: #888;
  margin-top: 2px;
}

.timeline-role {
  color: #aaa;
  font-style: italic;
}

.timeline-comment {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin-top: 4px;
  padding: 6px 10px;
  background: #f8f9fa;
  border-left: 3px solid #dee2e6;
  border-radius: 0 4px 4px 0;
  font-size: 0.82rem;
  color: #555;
  font-style: italic;
  
  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #aaa;
  }
}

/* ========================================
   CHILDREN ROWS (Main Table)
   ======================================== */
.row-child td {
  background: #f5f7fb !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  font-size: 0.88rem;
}

.td-child-indent {
  padding-left: 20px !important;
}

.child-connector {
  color: #aaa;
  font-weight: bold;
  margin-right: 6px;
}

.badge-children {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: rgba($primary, 0.08);
  color: $primary;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba($primary, 0.15);
  }
}

.badge-linked-count {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  padding: 2px 6px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 600;
  vertical-align: middle;
  
  svg {
    flex-shrink: 0;
  }
}

/* ========================================
   LINK MODAL MULTI-SELECT
   ======================================== */
.doc-check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: $primary;
    cursor: pointer;
  }
}

.search-input.mb-3 {
  margin-bottom: 12px;
}

.mt-3 {
  margin-top: 1rem !important;
}
</style>

<style>
/* Styles globaux pour les toasts SweetAlert2 */
.swal2-toast .swal2-title {
  font-size: 14px !important;
  font-weight: 500 !important;
}

.swal2-toast {
  font-size: 13px !important;
}
</style>
